import { toast } from "react-toastify";
import { TYPE_SHOW_NOTI, TYPE_GET_DATE, DailyChartHalotel } from "./const";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
import _, { forIn } from "lodash";

import * as XLSX from "xlsx-js-style";
import moment from "moment/moment";

export const sortDataNatcom = (data = []) => {
  const dataFormat = data.sort((a, b) => new Date(a.time) - new Date(b.time));
  return dataFormat;
};

export const formatDataTableDetailNatcom = (data = []) => {
  let filtered_array = _.filter(data, function (item) {
    return item.key !== "allday";
  });
  return filtered_array;
};

export const formatDataTimer = (data = []) => {
  if (_.isEmpty(data)) return [];
  return data.map((item = {}) => {
    const [year = "", month = "", day = ""] = item.time.split("-");
    return {
      ...item,
      time: `${day}/${month}`,
    };
  });
};

export const handleFormatDataDuplicate = (defineData) => {
  const uniqueArray = _.reduce(
    defineData,
    (result, item) => {
      const exists = result.some(
        (existingItem) => existingItem.hour === item.hour
      );
      if (!exists) {
        result.push(item);
      }
      return result;
    },
    []
  );
  return uniqueArray;
};

export const formatDataUniqueArray = (dataApi, uniqueFirst, uniqueLast) => {
  let datas = {};
  for (let x in dataApi) {
    const uniqueArray = _.reduce(
      dataApi[x],
      (result, item) => {
        const exists = result.some(
          (existingItem) =>
            existingItem[uniqueFirst] === item[uniqueFirst] &&
            existingItem[uniqueLast] === item[uniqueLast]
        );
        if (!exists) {
          result.push(item);
        }
        return result;
      },
      []
    );

    const lastItem = _.last(uniqueArray);
    datas = { ...datas, [x]: lastItem };
  }

  return datas;
};

export const getDateChangeTime = (type) => {
  dayjs.extend(customParseFormat);
  const currentDate = dayjs();

  if (type === TYPE_GET_DATE.now) {
    return currentDate.format("YYYY-MM-DD");
  }

  if (type === TYPE_GET_DATE.oneMonthAgo) {
    // Nếu đang trong ngày 1 - 5 của tháng hiện tại
    if (currentDate.date() >= 1 && currentDate.date() <= 5) {
      // lấy ngày mùng 1 của tháng trước
      return currentDate.subtract(1, "month").startOf("month").format("YYYY-MM-DD");
    }
    // ngược lại lấy ngày mùng 1 của tháng hiện tại
    return currentDate.startOf("month").format("YYYY-MM-DD");
  }

  if (type === TYPE_GET_DATE.oneDayAgo) {
    return currentDate.subtract(1, "day").format("YYYY-MM-DD");
  }
};


export const getLastDay = (type) => {
  const today = dayjs();
  const yesterday = today.subtract(1, "day");
  return yesterday.format("YYYY-MM-DD");
};

export function getUrlParamsFromJson(data) {
  return Object.keys(data)
    .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(data[key]))
    .join("&");
}

export const getDateTime = () => {
  var currentDate = new Date();

  var months = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  var daysOfWeek = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  var day = daysOfWeek[currentDate.getDay()];
  var month = months[currentDate.getMonth()];
  var year = currentDate.getFullYear();

  var formattedDate =
    day + ", " + month + " " + currentDate.getDate() + ", " + year;
  return formattedDate;
};

export const showToast = (type = TYPE_SHOW_NOTI.err, content = "") => {
  if (type === TYPE_SHOW_NOTI.err) {
    return toast.error(content, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  } else if (type === TYPE_SHOW_NOTI.success) {
    return toast.success(content, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "light",
    });
  }
};

export const formatDataHalotelRevenue = (dataHalotel, type) => {
  let data = [];
  if (type === DailyChartHalotel.revenue) {
    data = [
      { type: "Daily", revenue: 0, id: "revenue_day" },
      { type: "Weekly", revenue: 0, id: "revenue_week" },
      { type: "Monthly", revenue: 0, id: "revenue_month" },
    ];
  }
  if (type === DailyChartHalotel.quantity) {
    data = [
      { type: "Daily", revenue: 0, id: "quantity_day" },
      { type: "Weekly", revenue: 0, id: "quantity_week" },
      { type: "Monthly", revenue: 0, id: "quantity_month" },
    ];
  }

  if (type === DailyChartHalotel.channel) {
    data = [
      { type: "SMS", revenue: 0, id: "channel_sms" },
      {
        type: "Web/Wap",
        revenue: 0,
        id: "channel_web_wap",
      },
    ];
  }

  data.forEach((item) => {
    const dataDetail = dataHalotel[item.id];
    if (dataDetail) item.revenue = dataDetail;
    return item;
  });

  return data;
};

export const formatDataNatcomAirtime = (vm_natcom, vm_digicels) => {
  if (_.isEmpty(vm_natcom) || _.isEmpty(vm_digicels)) {
    return {};
  }
  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: 100,
      fixed: "left",
    },
    {
      title: "VM",
      children: [
        {
          title: "0 - SỐ LƯỢNG",
          dataIndex: "qty_0",
          key: "qty_0",
          width: "auto",
        },
        {
          title: " 0 - DOANH THU",
          dataIndex: "total_0",
          key: "total_0",
          width: "auto",
        },
        {
          title: "55 - SỐ LƯỢNG",
          dataIndex: "qty_55",
          key: "qty_55",
          width: "auto",
        },
        {
          title: "55- DOANH THU",
          dataIndex: "total_55",
          key: "total_55",
          width: "auto",
        },
        {
          title: "# - SỐ LƯỢNG",
          dataIndex: "qty_other",
          key: "qty_other",
          width: "auto",
        },
        {
          title: "# - DOANH THU",
          dataIndex: "total_other",
          key: "total_other",
          width: "auto",
        },
      ],
    },
    {
      title: "DIGICEL",
      children: [
        {
          title: "SỐ LƯỢNG",
          dataIndex: "qty_hour",
          key: "qty_hour",
          width: "auto",
        },
        {
          title: "DOANH THU",
          dataIndex: "total_hour",
          key: "total_hour",
          width: "auto",
        },
        {
          title: "TIME",
          dataIndex: "time_hour",
          key: "time_hour",
          width: "auto",
        },
      ],
    },
  ];

  let defineData = vm_natcom.map((item = {}, index) => {
    const data = { ...item, ...vm_digicels[index] } || {};
    const dataConvert = {
      key: data.hour,
      hour: data.hour,
      qty_0: formatDataNumberToen(+data.qty_0 || 0),
      total_0: formatDataNumberToen(+data.total_0 || 0),
      qty_55: formatDataNumberToen(+data.qty_55 || 0),
      total_55: formatDataNumberToen(+data.total_55 || 0),
      qty_other: formatDataNumberToen(+data.qty_other || 0),
      total_other: formatDataNumberToen(+data.total_other || 0),
      qty_hour: formatDataNumberToen(+data.qty_hour || 0),
      total_hour: formatDataNumberToen(+data.total_hour || 0),
      time_hour: formatDataNumberToen(+data.time_hour || 0),
    };
    return dataConvert;
  });

  const handleGetLastItem = (obj) => {
    const values = _.values(obj);
    const lastValue = _.last(values);
    return lastValue;
  };

  let lastItem =
    {
      ...handleGetLastItem(vm_natcom),
      ...handleGetLastItem(vm_digicels),
    } || {};
  const dataConvert = {
    key: "ALL DAY",
    hour: "ALL DAY",
    qty_0: formatDataNumberToen(+lastItem?.qty_day_0 || 0),
    total_0: formatDataNumberToen(+lastItem?.total_day_0 || 0),
    qty_55: formatDataNumberToen(+lastItem?.qty_day_55 || 0),
    total_55: formatDataNumberToen(+lastItem?.total_day_55 || 0),
    qty_other: formatDataNumberToen(+lastItem?.qty_day_other || 0),
    total_other: formatDataNumberToen(+lastItem?.total_day_other || 0),
    qty_hour: formatDataNumberToen(+lastItem?.qty_day || 0),
    total_hour: formatDataNumberToen(+lastItem?.total_day || 0),
    time_hour: formatDataNumberToen(+lastItem?.time_day || 0),
  };

  defineData = [...defineData, dataConvert];

  const uniqueArray = _.reduce(
    defineData,
    (result, item) => {
      const exists = result.some(
        (existingItem) => existingItem.hour === item.hour
      );
      if (!exists) {
        result.push(item);
      }
      return result;
    },
    []
  );
  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(uniqueArray),
  };

  return columns;
};

export const formatDataBitelAirtime = (airtime_bitel) => {
  if (_.isEmpty(airtime_bitel)) {
    return {};
  }
  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: 100,
      fixed: "left",
    },
    {
      title: "Tổng tiền ứng + phí",
      dataIndex: "hourly_advance_fee",
      key: "hourly_advance_fee",
      width: "auto",
    },
    {
      title: "Tổng phí",
      dataIndex: "hourly_fee",
      key: "hourly_fee",
      width: "auto",
    },
    {
      title: "Tổng giao dịch ứng",
      dataIndex: "hourly_advance",
      key: "hourly_advance",
      width: "auto",
    },
    {
      title: "Tổng tiền thu hồi gốc + phí",
      dataIndex: "hourly_recovery_origin_fee",
      key: "hourly_recovery_origin_fee",
      width: "auto",
    },
    {
      title: "Tổng tiền thu hồi phí",
      dataIndex: "hourly_recovery_fee",
      key: "hourly_recovery_fee",
      width: "auto",
    },
    {
      title: "Tổng giao dịch thu hồi",
      dataIndex: "hourly_trans_recovery",
      key: "hourly_trans_recovery",
      width: "auto",
    },
  ];

  let defineData = airtime_bitel.map((item = {}, index) => {
    const data = { ...item } || {};
    const dataConvert = {
      key: data.hour,
      hour: data.hour,
      hourly_advance_fee: formatDataNumberToen(
        +data.hourly_advance_fee / 100 || 0
      ),
      hourly_fee: formatDataNumberToen(+data.hourly_fee / 100 || 0),
      hourly_advance: formatDataNumberToen(+data.hourly_advance || 0),
      hourly_recovery_origin_fee: formatDataNumberToen(
        +data.hourly_recovery_origin_fee / 100 || 0
      ),
      hourly_recovery_fee: formatDataNumberToen(
        +data.hourly_recovery_fee / 100 || 0
      ),
      hourly_trans_recovery: formatDataNumberToen(
        +data.hourly_trans_recovery || 0
      ),
    };
    return dataConvert;
  });

  const handleGetLastItem = (obj) => {
    const values = _.values(obj);
    const lastValue = _.last(values);
    return lastValue;
  };

  let lastItem =
    {
      ...handleGetLastItem(airtime_bitel),
    } || {};

  const dataConvert = {
    key: "ALL DAY",
    hour: "ALL DAY",
    hourly_advance_fee: formatDataNumberToen(
      +lastItem?.total_advance_fee / 100 || 0
    ),
    hourly_fee: formatDataNumberToen(+lastItem?.total_fee / 100 || 0),
    hourly_advance: formatDataNumberToen(+lastItem?.total_advance || 0),
    hourly_recovery_origin_fee: formatDataNumberToen(
      +lastItem?.total_recovery_origin_fee / 100 || 0
    ),
    hourly_recovery_fee: formatDataNumberToen(
      +lastItem?.total_recovery_fee / 100 || 0
    ),
    hourly_trans_recovery: formatDataNumberToen(
      +lastItem?.total_trans_recovery || 0
    ),
  };

  defineData = [...defineData, dataConvert];

  const uniqueArray = _.reduce(
    defineData,
    (result, item) => {
      const exists = result.some(
        (existingItem) => existingItem.hour === item.hour
      );
      if (!exists) {
        result.push(item);
      }
      return result;
    },
    []
  );
  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(uniqueArray),
  };

  return columns;
};

export const formatDataBitelAirtimeByDate = (airtime_bitel) => {
  if (_.isEmpty(airtime_bitel)) {
    return {};
  }
  const datakey = [
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      width: "auto",
      fixed: "left",
    },
    {
      title: "Tổng tiền ứng + phí",
      dataIndex: "total_advance_fee",
      key: "total_advance_fee",
      width: "auto",
    },
    {
      title: "Tổng phí",
      dataIndex: "total_fee",
      key: "total_fee",
      width: "auto",
    },
    {
      title: "Tổng giao dịch ứng",
      dataIndex: "total_advance",
      key: "total_advance",
      width: "auto",
    },
    {
      title: "Tổng tiền thu hồi gốc + phí",
      dataIndex: "total_recovery_origin_fee",
      key: "total_recovery_origin_fee",
      width: "auto",
    },
    {
      title: "Tổng tiền thu hồi phí",
      dataIndex: "total_recovery_fee",
      key: "total_recovery_fee",
      width: "auto",
    },
    {
      title: "Tổng giao dịch thu hồi",
      dataIndex: "total_trans_recovery",
      key: "total_trans_recovery",
      width: "auto",
    },
  ];

  const dataTotal = {
    key: "TOTAL",
    date: "TOTAL",
    total_advance_fee: 0,
    total_fee: 0,
    total_advance: 0,
    total_recovery_origin_fee: 0,
    total_recovery_fee: 0,
    total_trans_recovery: 0,
  };

  let defineData = airtime_bitel.map((item = {}, index) => {
    const data = { ...item } || {};
    const dataConvert = {
      key: data.date,
      date: data.date,
      total_advance_fee: formatDataNumberToen(
        +data.total_advance_fee / 100 || 0
      ),
      total_fee: formatDataNumberToen(+data.total_fee / 100 || 0),
      total_advance: formatDataNumberToen(+data.total_advance || 0),
      total_recovery_origin_fee: formatDataNumberToen(
        +data.total_recovery_origin_fee / 100 || 0
      ),
      total_recovery_fee: formatDataNumberToen(
        +data.total_recovery_fee / 100 || 0
      ),
      total_trans_recovery: formatDataNumberToen(
        +data.total_trans_recovery || 0
      ),
    };
    dataTotal.total_advance_fee += item.total_advance_fee / 100;
    dataTotal.total_fee += item.total_fee / 100;
    dataTotal.total_advance += item.total_advance;
    dataTotal.total_recovery_origin_fee += item.total_recovery_origin_fee / 100;
    dataTotal.total_recovery_fee += item.total_recovery_fee / 100;
    dataTotal.total_trans_recovery += item.total_trans_recovery;
    return dataConvert;
  });
  dataTotal.total_advance_fee = formatDataNumberToen(
    dataTotal.total_advance_fee
  );
  dataTotal.total_fee = formatDataNumberToen(dataTotal.total_fee);
  dataTotal.total_advance = formatDataNumberToen(dataTotal.total_advance);
  dataTotal.total_recovery_origin_fee = formatDataNumberToen(
    dataTotal.total_recovery_origin_fee
  );
  dataTotal.total_recovery_fee = formatDataNumberToen(
    dataTotal.total_recovery_fee
  );
  dataTotal.total_trans_recovery = formatDataNumberToen(
    dataTotal.total_trans_recovery
  );

  defineData = [...defineData, dataTotal];

  const columns = {
    dataKey: datakey,
    defineData: defineData,
  };

  return columns;
};

export const formatDataNatAirtime = (airtime_bitel) => {
  if (_.isEmpty(airtime_bitel)) {
    return {};
  }
  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: 100,
      fixed: "left",
    },
    {
      title: "Tổng tiền ứng + phí",
      dataIndex: "total_advance_fee",
      key: "total_advance_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_advance_fee}</div>
            <div className="">BASIC: {all.basic_advance_fee}</div>
            <div className="">KM: {all.km_advance_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng phí",
      dataIndex: "total_fee",
      key: "total_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_fee}</div>
            <div className="">BASIC: {all.basic_fee}</div>
            <div className="">KM: {all.km_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng giao dịch ứng",
      dataIndex: "total_advance",
      key: "total_advance",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_advance}</div>
            <div className="">BASIC: {all.basic_advance}</div>
            <div className="">KM: {all.km_advance}</div>
          </>
        );
      },
    },
    {
      title: "Tổng tiền thu hồi gốc + phí",
      dataIndex: "total_recovery_origin_fee",
      key: "total_recovery_origin_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_recovery_origin_fee}</div>
            <div className="">BASIC: {all.basic_recovery_origin_fee}</div>
            <div className="">KM: {all.km_recovery_origin_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng tiền thu hồi phí",
      dataIndex: "total_recovery_fee",
      key: "total_recovery_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_recovery_fee}</div>
            <div className="">BASIC: {all.basic_recovery_fee}</div>
            <div className="">KM: {all.km_recovery_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng giao dịch thu hồi",
      dataIndex: "total_trans_recovery",
      key: "total_trans_recovery",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_trans_recovery}</div>
            <div className="">BASIC: {all.basic_trans_recovery}</div>
            <div className="">KM: {all.km_trans_recovery}</div>
          </>
        );
      },
    },
  ];

  let defineData = airtime_bitel.map((item = {}, index) => {
    const data = { ...item } || {};
    const dataConvert = {
      key: data.hour,
      hour: data.hour,

      km_advance_fee: formatDataNumberToen((+data.total_advance_fee - Number(data.basic_advance_fee)) / 100 || 0),
      basic_advance_fee: formatDataNumberToen(
        +data.basic_advance_fee / 100 || 0
      ),
      total_advance_fee: formatDataNumberToen(
        +data.total_advance_fee / 100 || 0
      ),

      total_fee: formatDataNumberToen(+data.total_fee / 100 || 0),
      basic_fee: formatDataNumberToen(+data.basic_fee / 100 || 0),
      km_fee: formatDataNumberToen((+data.total_fee - Number(data.basic_fee)) / 100 || 0),

      total_advance: formatDataNumberToen(+data.total_advance || 0),
      basic_advance: formatDataNumberToen(+data.basic_advance || 0),
      km_advance: formatDataNumberToen(+data.total_advance - Number(data.basic_advance) || 0),

      total_recovery_origin_fee: formatDataNumberToen(
        +data.total_recovery_origin_fee / 100 || 0
      ),
      basic_recovery_origin_fee: formatDataNumberToen(
        +data.basic_recovery_origin_fee / 100 || 0
      ),
      km_recovery_origin_fee: formatDataNumberToen((+data.total_recovery_origin_fee - Number(data.basic_recovery_origin_fee)) / 100 || 0),

      total_recovery_fee: formatDataNumberToen(
        +data.total_recovery_fee / 100 || 0
      ),
      basic_recovery_fee: formatDataNumberToen(
        +data.basic_recovery_fee / 100 || 0
      ),
      km_recovery_fee: formatDataNumberToen((+data.total_recovery_fee - Number(data.basic_recovery_fee)) / 100 || 0),

      total_trans_recovery: formatDataNumberToen(
        +data.total_trans_recovery || 0
      ),
      basic_trans_recovery: formatDataNumberToen(
        +data.basic_trans_recovery || 0
      ),
      km_trans_recovery: formatDataNumberToen(+data.total_trans_recovery - Number(data.basic_trans_recovery) || 0),
    };
    return dataConvert;
  });

//   const handleGetLastItem = (obj) => {
//     const values = _.values(obj);
//     const lastValue = _.last(values);
//     return lastValue;
//   };
// 
//   let lastItem =
//     {
//       ...handleGetLastItem(defineData),
//     } || {};
//     
//   // format total number
//   for (const key in lastItem) {
//     if(typeof(lastItem[key]) === "number"){
//       lastItem[key]=formatDataNumberToen(lastItem[key])
//     }
//   }
//   const dataConvert = {
//     ...lastItem,
//     key: "ALL DAY",
//     hour: "ALL DAY",
//   };
    let totals = {
      basic_advance: 0,
      basic_advance_fee: 0,
      basic_fee: 0,
      basic_recovery_fee: 0,
      basic_recovery_origin_fee: 0,
      basic_trans_recovery: 0,
      km_advance: 0,
      km_advance_fee: 0,
      km_fee: 0,
      km_recovery_fee: 0,
      km_recovery_origin_fee: 0,
      km_trans_recovery: 0,
      total_advance: 0,
      total_advance_fee: 0,
      total_fee: 0,
      total_recovery_fee: 0,
      total_recovery_origin_fee: 0,
      total_trans_recovery: 0,
    };

    for (const key in defineData) {
      const item = defineData[key];

      for (const field in totals) {
        const value = Number((item[field] || "0").toString().replace(/,/g, ""));
        totals[field] += value;
      }
    }

    // Format lại số
    for (const field in totals) {
      totals[field] = formatDataNumberToen(totals[field]);
    }

    // Tạo dòng tổng
    const dataConvert = {
      ...totals,
      key: "ALL DAY",
      hour: "ALL DAY",
    };

  console.log('dataConvert:: ', dataConvert);
  // console.log('lastItem:: ', lastItem);


  

  defineData = [...defineData, dataConvert];

  const uniqueArray = _.reduce(
    defineData,
    (result, item) => {
      const exists = result.some(
        (existingItem) => existingItem.hour === item.hour
      );
      if (!exists) {
        result.push(item);
      }
      return result;
    },
    []
  );
  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(uniqueArray),
  };

  return columns;
};
export const formatDataNatAirtimeTable = (airtime) => {
  if (_.isEmpty(airtime)) {
    return {};
  }
  const datakey = [
    {
      title: "DATE",
      dataIndex: "date",
      key: "date",
      width: "auto",
      fixed: "left",
    },
    {
      title: "Tổng tiền ứng + phí",
      dataIndex: "total_advance_fee",
      key: "total_advance_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_advance_fee}</div>
            <div className="">BASIC: {all.basic_advance_fee}</div>
            <div className="">KM: {all.km_advance_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng phí",
      dataIndex: "total_fee",
      key: "total_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_fee}</div>
            <div className="">BASIC: {all.basic_fee}</div>
            <div className="">KM: {all.km_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng giao dịch ứng",
      dataIndex: "total_advance",
      key: "total_advance",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_advance}</div>
            <div className="">BASIC: {all.basic_advance}</div>
            <div className="">KM: {all.km_advance}</div>
          </>
        );
      },
    },
    {
      title: "Tổng tiền thu hồi gốc + phí",
      dataIndex: "total_recovery_origin_fee",
      key: "total_recovery_origin_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_recovery_origin_fee}</div>
            <div className="">BASIC: {all.basic_recovery_origin_fee}</div>
            <div className="">KM: {all.km_recovery_origin_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng tiền thu hồi phí",
      dataIndex: "total_recovery_fee",
      key: "total_recovery_fee",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_recovery_fee}</div>
            <div className="">BASIC: {all.basic_recovery_fee}</div>
            <div className="">KM: {all.km_recovery_fee}</div>
          </>
        );
      },
    },
    {
      title: "Tổng giao dịch thu hồi",
      dataIndex: "total_trans_recovery",
      key: "total_trans_recovery",
      width: "auto",
      render: (text, all) => {
        return (
          <>
            <div className="">TOTAL: {all.total_trans_recovery}</div>
            <div className="">BASIC: {all.basic_trans_recovery}</div>
            <div className="">KM: {all.km_trans_recovery}</div>
          </>
        );
      },
    },
  ];

  const dataTotal = {
    key: "TOTAL",
    date: "TOTAL",
    total_advance_fee: 0,
    basic_advance_fee : 0,
    km_advance_fee : 0,

    total_fee: 0,
    basic_fee : 0,
    km_fee : 0,

    total_advance: 0,
    basic_advance: 0,
    km_advance: 0,

    total_recovery_origin_fee: 0,
    basic_recovery_origin_fee: 0,
    km_recovery_origin_fee: 0,

    total_recovery_fee: 0,
    basic_recovery_fee: 0,
    km_recovery_fee: 0,

    total_trans_recovery: 0,
    basic_trans_recovery: 0,
    km_trans_recovery: 0,
  };
const newData = [...airtime]
  let defineData = newData.map((item = {}, index) => {
    const data = { ...item } || {};
    const dataConvert = {
      key: data.date,
      date: data.date,
      total_advance_fee: formatDataNumberToen(
        +data.total_advance_fee / 100 || 0
      ),
      basic_advance_fee: formatDataNumberToen(
        +data.basic_advance_fee / 100 || 0
      ),
      km_advance_fee: formatDataNumberToen((+data.total_advance_fee - Number(data.basic_advance_fee)) / 100 || 0),
      
      total_fee: formatDataNumberToen(+data.total_fee / 100 || 0),
      basic_fee: formatDataNumberToen(+data.basic_fee / 100 || 0),
      km_fee: formatDataNumberToen((+data.total_fee - Number(data.basic_fee)) / 100 || 0),

      total_advance: formatDataNumberToen(+data.total_advance || 0),
      basic_advance: formatDataNumberToen(+data.basic_advance || 0),
      km_advance: formatDataNumberToen(+data.total_advance - Number(data.basic_advance) || 0),

      total_recovery_origin_fee: formatDataNumberToen(
        +data.total_recovery_origin_fee / 100 || 0
      ),
      basic_recovery_origin_fee: formatDataNumberToen(
        +data.basic_recovery_origin_fee / 100 || 0
      ),
      km_recovery_origin_fee: formatDataNumberToen((+data.total_recovery_origin_fee - Number(data.basic_recovery_origin_fee)) / 100 || 0),

      total_recovery_fee: formatDataNumberToen(
        +data.total_recovery_fee / 100 || 0
      ),
      basic_recovery_fee: formatDataNumberToen(
        +data.basic_recovery_fee / 100 || 0
      ),
      km_recovery_fee: formatDataNumberToen((+data.total_recovery_fee - Number(data.basic_recovery_fee)) / 100 || 0),

      total_trans_recovery: formatDataNumberToen(
        +data.total_trans_recovery || 0
      ),
      basic_trans_recovery: formatDataNumberToen(
        +data.basic_trans_recovery || 0
      ),
      km_trans_recovery: formatDataNumberToen(+data.total_trans_recovery - Number(data.basic_trans_recovery) || 0),
    };
    dataTotal.total_advance_fee += item.total_advance_fee / 100;
    dataTotal.total_fee += item.total_fee / 100;
    dataTotal.total_advance += item.total_advance;
    dataTotal.total_recovery_origin_fee += item.total_recovery_origin_fee / 100;
    dataTotal.total_recovery_fee += item.total_recovery_fee / 100;
    dataTotal.total_trans_recovery += item.total_trans_recovery;

    dataTotal.basic_advance_fee += item.basic_advance_fee / 100;
    dataTotal.basic_fee += item.basic_fee / 100;
    dataTotal.basic_advance += item.basic_advance;
    dataTotal.basic_recovery_origin_fee += item.basic_recovery_origin_fee / 100;
    dataTotal.basic_recovery_fee += item.basic_recovery_fee / 100;
    dataTotal.basic_trans_recovery += item.basic_trans_recovery;

    dataTotal.km_advance_fee += (+item.total_advance_fee - Number(item.basic_advance_fee)) / 100 || 0;
    dataTotal.km_fee += (+data.total_fee - Number(data.basic_fee)) / 100 || 0;
    dataTotal.km_advance += (+data.total_advance - Number(data.basic_advance)) || 0
    dataTotal.km_recovery_origin_fee += (+data.total_recovery_origin_fee - Number(data.basic_recovery_origin_fee)) / 100 || 0;
    dataTotal.km_recovery_fee += (+data.total_recovery_fee - Number(data.basic_recovery_fee)) / 100 || 0;
    dataTotal.km_trans_recovery += +data.total_trans_recovery - Number(data.basic_trans_recovery) || 0;
    return dataConvert;
  });

  // format total number
  for (const key in dataTotal) {
    if(typeof(dataTotal[key]) === "number"){
      dataTotal[key]=formatDataNumberToen(dataTotal[key])
    }
  }
  
  defineData = [...defineData, dataTotal];

  const columns = {
    dataKey: datakey,
    defineData: defineData,
  };

  return columns;
};

export const formatDataNatcomAirtimeNtmDetail = (ntm) => {
  if (_.isEmpty(ntm)) {
    return {};
  }

  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: "auto",
    },
    {
      title: " 0 - SỐ LƯỢNG",
      dataIndex: "qty_hour",
      key: "qty_hour",
      width: "auto",
    },
    {
      title: "0 - DOANH THU",
      dataIndex: "total_hour",
      key: "total_hour",
      width: "auto",
    },
    {
      title: "Notify",
      dataIndex: "notify",
      key: "notify",
      width: "auto",
    },
  ];

  const formatData = handleFormatDataDuplicate(ntm);

  let defineData = formatData.map((item = {}, index) => {
    const dataConvert = {
      key: item.hour,
      hour: item.hour,
      qty_hour: formatDataNumberToen(+item.qty_hour || 0),
      total_hour: formatDataNumberToen(+item.total_hour || 0),
      notify: formatDataNumberToen(+item.notify || 0),
    };

    return dataConvert;
  });

  const handleGetLastItem = (obj) => {
    const values = _.values(obj);
    const lastValue = _.last(values);
    return lastValue;
  };

  const lastItem = handleGetLastItem(formatData);
  const dataAllday = {
    key: "ALL DAY",
    hour: "ALL DAY",
    qty_hour: formatDataNumberToen(+lastItem.qty_day || 0),
    total_hour: formatDataNumberToen(+lastItem.total_day || 0),
    notify: formatDataNumberToen(+lastItem.notify || 0),
  };

  defineData = [...defineData, dataAllday];

  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(defineData),
  };

  return columns;
};
export const formatDataErrorCodeMytel = (data, tabDetail = false) => {
  if (_.isEmpty(data)) {
    return {};
  }
  if(tabDetail){
    data = data.sort((a, b) => new Date(a.report_date) - new Date(b.report_date)); 
  }

  const datakey = [
    {
      title: "Report date",
      dataIndex: "report_date",
      key: "report_date",
      width: "auto",
      render: (text) => text != 'Total' ? moment(text).format(tabDetail ? "YYYY-MM-DD HH:mm" : "YYYY-MM-DD") : 'Total'

    },
    {
      title: "Code 0",
      dataIndex: "code_0",
      key: "code_0",
      width: "auto",
    },
    {
      title: "Code -1",
      dataIndex: "code_1",
      key: "code_1",
      width: "auto",
    },
    {
      title: "Code 417",
      dataIndex: "code_417",
      key: "code_417",
      width: "auto",
    },
    {
      title: "Code orther",
      dataIndex: "code_orther",
      key: "code_orther",
      width: "auto",
    },
  ];

  let dataAllday = data.reduce((acc, item) => {
    acc.report_date = "Total";
    acc.code_0 = (acc.code_0 || 0) + (item.code_0 || 0);
    acc.code_1 = (acc.code_1 || 0) + (item.code_1 || 0);
    acc.code_417 = (acc.code_417 || 0) + (item.code_417 || 0);
    acc.code_orther = (acc.code_orther || 0) + (item.code_orther || 0);
    return acc;
  }, {});

  let defineData = tabDetail ? data : [...data, dataAllday];
  
  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(defineData),
  };

  return columns;
};
export const formatDataVmailUnitelNtmDetail = (ntm) => {
  if (_.isEmpty(ntm)) {
    return {};
  }

  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: "auto",
    },
    {
      title: "Code",
      dataIndex: "code",
      key: "code",
      width: "auto",
    },
    {
      title: "Quantity VM",
      dataIndex: "qty_vm",
      key: "qty_vm",
      width: "auto",
    },
    {
      title: "Total Fee",
      dataIndex: "total_fee",
      key: "total_fee",
      width: "auto",
    },
    {
      title: "Total duration VM",
      dataIndex: "total_duration",
      key: "total_duration",
      width: "auto",
    },
    {
      title: "Total miss call",
      dataIndex: "total_missed_call",
      key: "total_missed_call",
      width: "auto",
    },
    {
      title: "Total listen again",
      dataIndex: "total_listen_again",
      key: "total_listen_again",
      width: "auto",
    },
  ];

  const formatData = handleFormatDataDuplicate(ntm);

  let defineData = formatData.map((item = {}, index) => {
    const dataConvert = {
      key: item.hour,
      hour: item.hour,
      code: formatDataNumberToen(+item.code || 0),
      qty_vm: formatDataNumberToen(+item.qty_vm || 0),
      total_fee: formatDataNumberToen(+item.total_fee || 0),
      total_duration: formatDataNumberToen(+item.total_duration || 0),
      total_missed_call: formatDataNumberToen(+item.total_missed_call || 0),
      total_listen_again: formatDataNumberToen(+item.total_listen_again || 0),
    };

    return dataConvert;
  });

  const handleGetLastItem = (obj) => {
    const values = _.values(obj);
    const lastValue = _.last(values);
    return lastValue;
  };

  const lastItem = handleGetLastItem(formatData);
  const dataAllday = {
    key: "ALL DAY",
    hour: "ALL DAY",
    qty_vm: formatDataNumberToen(+lastItem.d_qty_vm || 0),
    total_fee: formatDataNumberToen(+lastItem.d_total_fee || 0),
    total_duration: formatDataNumberToen(+lastItem.d_total_duration || 0),
    total_missed_call: formatDataNumberToen(+lastItem.d_total_missed_call || 0),
    total_listen_again: formatDataNumberToen(
      +lastItem.d_total_listen_again || 0
    ),
  };

  defineData = [...defineData, dataAllday];

  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(defineData),
  };

  return columns;
};
export const formatDataVmailMytel = (ntm) => {
  if (_.isEmpty(ntm)) {
    return {};
  }

  const datakey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: "auto",
    },
    {
      title: "Total Call",
      dataIndex: "total_call",
      key: "total_call",
      width: "auto",
    },
    {
      title: "Total Miss Call",
      dataIndex: "total_miss_call",
      key: "total_miss_call",
      width: "auto",
    },
    {
      title: "Total Call Service",
      dataIndex: "total_call_service",
      key: "total_call_service",
      width: "auto",
    },
    {
      title: "Total VM",
      dataIndex: "total_vm",
      key: "total_vm",
      width: "auto",
    },
    {
      title: "Total VM Duration",
      dataIndex: "total_vm_duration",
      key: "total_vm_duration",
      width: "auto",
    },
    {
      title: "Total Service Duration",
      dataIndex: "total_service_duration",
      key: "total_service_duration",
      width: "auto",
    },
    {
      title: "Total Revenue",
      dataIndex: "total_fee",
      key: "total_fee",
      width: "auto",
    },
  ];

  const formatData = handleFormatDataDuplicate(ntm);

  let defineData = formatData.map((item = {}, index) => {
    const dataConvert = {
      key: item.hour,
      hour: item.hour,
      total_call: formatDataNumberToen(+item.total_call || 0),
      total_miss_call: formatDataNumberToen(+item.total_miss_call || 0),
      total_call_service: formatDataNumberToen(+item.total_call_service || 0),
      total_vm: formatDataNumberToen(+item.total_vm || 0),
      total_vm_duration: formatDataNumberToen(+item.total_vm_duration || 0),
      total_service_duration: formatDataNumberToen(+item.total_service_duration || 0),
      total_fee: formatDataNumberToen(+item.total_fee || 0),
    };

    return dataConvert;
  });

  const dataAllday = formatData.reduce(
    (acc, item) => {
      acc.total_call += +item.total_call || 0;
      acc.total_miss_call += +item.total_miss_call || 0;
      acc.total_call_service += +item.total_call_service || 0;
      acc.total_vm += +item.total_vm || 0;
      acc.total_vm_duration += +item.total_vm_duration || 0;
      acc.total_service_duration += +item.total_service_duration || 0;
      acc.total_fee += +item.total_fee || 0;
      return acc;
    },
    {
      key: "ALL DAY",
      hour: "ALL DAY",
      total_call: 0,
      total_miss_call: 0,
      total_call_service: 0,
      total_vm: 0,
      total_vm_duration: 0,
      total_service_duration: 0,
      total_fee: 0,
    }
  );

  Object.keys(dataAllday).forEach((key) => {
    if (key !== "key" && key !== "hour") {
      dataAllday[key] = formatDataNumberToen(dataAllday[key]);
    }
  });

  defineData = [...defineData, dataAllday];

  const columns = {
    dataKey: datakey,
    defineData: formatDataTableDetailNatcom(defineData),
  };

  return columns;
};

export const dataKeyTableAirtimeNatcom = [
  {
    title: "Ngày",
    dataIndex: "date",
    key: "date",
    width: "auto",
    align: "center",
    render: (_, record) => {
      return <div className={`${_ ? "timer-active" : "hidden-cell"}`}>{_}</div>;
    },
  },
  {
    title: "",
    dataIndex: "airtime",
    key: "airtime",
    with: "auto",
    render: (_, record) => {
      return <div className="border-right__tables">{_}</div>;
    },
  },
  {
    title: "Tổng tiền ứng + phí",
    dataIndex: "total_advance_fee",
    key: "total_advance_fee",
    width: "auto",
  },
  {
    title: "Tổng phí",
    dataIndex: "total_fee",
    key: "total_fee",
    width: "auto",
  },
  {
    title: "Tổng giao dịch ứng",
    dataIndex: "total_advance",
    key: "total_advance",
    width: "auto",
  },
  {
    title: "Tổng tiền thu hồi gốc + phí",
    dataIndex: "total_recovery_origin_fee",
    key: "total_recovery_origin_fee",
    width: "auto",
  },
  {
    title: "Tổng tiền thu hồi phí",
    dataIndex: "total_recovery_fee",
    key: "total_recovery_fee",
    width: "auto",
  },
  {
    title: "Tổng giao dịch thu hồi",
    dataIndex: "total_trans_recovery",
    key: "total_trans_recovery",
    width: "auto",
  },
];

export const formatDataNatcomAirtimeDetail = (
  data = [],
  date = "",
  isOverview // can be "overview" (string) or boolean true
) => {
  console.log('data: ', data);
  // trả về mảng rỗng nếu không có data
  if (!Array.isArray(data) || data.length === 0) return [];

  // xác định mode
  const overviewMode = isOverview === "overview" || isOverview === true;

  // các key cần cộng và có/không chia 100
  const keysDivide100 = [
    "basic_advance_fee",
    "basic_fee",
    "basic_recovery_fee",
    "basic_recovery_origin_fee",
    "basic_trans_recovery",
    "total_advance_fee",
    "total_fee",
    "total_recovery_fee",
    "total_recovery_origin_fee",
    "total_trans_recovery",
  ];
  const keysNoDivide = ["basic_advance", "total_advance"];

  // khởi tạo totals
  const totals = {};
  [...keysDivide100, ...keysNoDivide].forEach((k) => (totals[k] = 0));

  // cộng dồn tất cả bản ghi trong ngày
  for (const row of data) {
    if (!row) continue;
    keysDivide100.forEach((k) => {
      const v = row[k] === undefined || row[k] === null ? 0 : Number(row[k]);
      totals[k] += isNaN(v) ? 0 : v;
    });
    keysNoDivide.forEach((k) => {
      const v = row[k] === undefined || row[k] === null ? 0 : Number(row[k]);
      totals[k] += isNaN(v) ? 0 : v;
    });
  }

  // áp dụng chia 100 cho các key cần chia (theo logic cũ)
  keysDivide100.forEach((k) => {
    totals[k] = totals[k] / 100;
  });

  // helper để trả số raw khi overview, hoặc formatted khi hourly/display
  const asNumber = (v) => Number(v || 0);
  const asDisplay = (v) => formatDataNumberToen(Number(v || 0));

  const defineData = [
    {
      date,
      airtime: "TOTAL",
      total_advance_fee: overviewMode ? asNumber(totals.total_advance_fee) : asDisplay(totals.total_advance_fee),
      total_fee: overviewMode ? asNumber(totals.total_fee) : asDisplay(totals.total_fee),
      total_advance: overviewMode ? asNumber(totals.total_advance) : asDisplay(totals.total_advance),
      total_recovery_origin_fee: overviewMode ? asNumber(totals.total_recovery_origin_fee) : asDisplay(totals.total_recovery_origin_fee),
      total_recovery_fee: overviewMode ? asNumber(totals.total_recovery_fee) : asDisplay(totals.total_recovery_fee),
      total_trans_recovery: overviewMode ? asNumber(totals.total_trans_recovery) : asDisplay(totals.total_trans_recovery),
      idData: date,
      _rawTotals: { ...totals } // optional: để debug nếu cần
    },
    {
      date,
      airtime: "BASIC",
      total_advance_fee: overviewMode ? asNumber(totals.basic_advance_fee) : asDisplay(totals.basic_advance_fee),
      total_fee: overviewMode ? asNumber(totals.basic_fee) : asDisplay(totals.basic_fee),
      total_advance: overviewMode ? asNumber(totals.basic_advance) : asDisplay(totals.basic_advance),
      total_recovery_origin_fee: overviewMode ? asNumber(totals.basic_recovery_origin_fee) : asDisplay(totals.basic_recovery_origin_fee),
      total_recovery_fee: overviewMode ? asNumber(totals.basic_recovery_fee) : asDisplay(totals.basic_recovery_fee),
      total_trans_recovery: overviewMode ? asNumber(totals.basic_trans_recovery) : asDisplay(totals.basic_trans_recovery),
      idData: date,
    },
  ];

  return defineData;
};

export const formatDataBitelAirtimeDetail = (
  data = [],
  date = "",
  isOverview
) => {
  const airtime = data[data.length - 1] || {};
  for (let x in airtime) {
    if (x != "total_advance" && x != "total_trans_recovery") {
      airtime[x] = Number(airtime[x]) / 100;
    }
  }
  if (_.isEmpty(airtime)) {
    return {};
  }

  const defineData = [
    {
      date: "",
      airtime: "TOTAL",
      total_advance_fee: isOverview
        ? +airtime.total_advance_fee || 0
        : formatDataNumberToen(+airtime.total_advance_fee || 0),
      total_fee: isOverview
        ? +airtime.total_fee || 0
        : formatDataNumberToen(+airtime.total_fee || 0),
      total_advance: isOverview
        ? +airtime.total_advance || 0
        : formatDataNumberToen(+airtime.total_advance || 0),
      total_recovery_origin_fee: isOverview
        ? +airtime.total_recovery_origin_fee || 0
        : formatDataNumberToen(+airtime.total_recovery_origin_fee || 0),
      total_recovery_fee: isOverview
        ? +airtime.total_recovery_fee || 0
        : formatDataNumberToen(+airtime.total_recovery_fee || 0),
      total_trans_recovery: isOverview
        ? +airtime.total_trans_recovery || 0
        : formatDataNumberToen(+airtime.total_trans_recovery || 0),
      idData: date,
    },
    {
      date,
      airtime: "HOURLY",
      total_advance_fee: formatDataNumberToen(+airtime.hourly_advance_fee || 0),
      total_fee: formatDataNumberToen(+airtime.hourly_fee || 0),
      total_advance: formatDataNumberToen(+airtime.hourly_advance || 0),
      total_recovery_origin_fee: formatDataNumberToen(
        +airtime.hourly_recovery_origin_fee || 0
      ),
      total_recovery_fee: formatDataNumberToen(
        +airtime.hourly_recovery_fee || 0
      ),
      total_trans_recovery: formatDataNumberToen(
        +airtime.hourly_trans_recovery || 0
      ),
      idData: date,
    },
  ];

  return defineData;
};

export const formatDataNatcomAirtimCompate = (
  vm_natcom,
  startDate,
  endDate,
  isNtm = false,
  isQtyNatcom = false
) => {
  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (isNtm) {
        total += datas?.total_hour;
      } else if (isQtyNatcom) {
        total += datas?.qty_0;
      } else {
        total += datas?.total_0;
      }
      defineData[i].total_hour = total || 0;
    }

    return defineData;
  };
  const formatDataStartDate = handleFormatDataDuplicate(vm_natcom[startDate]);
  const formatDataEndData = handleFormatDataDuplicate(vm_natcom[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};

export const formatDataVmailBitelCompate = (
  airtime_bitel,
  startDate,
  endDate,
  isAdvance = false
) => {
  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (isAdvance) {
        total = +datas?.hourly_advance_fee / 100;
      } else {
        total = +datas?.hourly_recovery_origin_fee / 100;
      }
      defineData[i].total_hour = total || 0;
    }

    return defineData;
  };
  const formatDataStartDate = handleFormatDataDuplicate(
    airtime_bitel[startDate]
  );
  const formatDataEndData = handleFormatDataDuplicate(airtime_bitel[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};
export const formatDataVmailNatcomMissCall = (
  missCallData,
  startDate,
  endDate,
  isTotal = false,
  isCheckSub = false,
  isNotEnough = false,
  isCancel = false,
  isInvalid = false,
) => {
  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (isTotal) {
        total = +datas?.total;
      } else if(isCheckSub) {
        total = +datas?.check_sub_error;
      } else if(isNotEnough) {
        total = +datas?.not_enough_money;
      } else if(isCancel) {
        total = +datas?.cancel;
      } else if(isInvalid) {
        total = +datas?.call_invalid;
      }
      defineData[i].total_hour = total || 0;
    }

    return defineData;
  };
  const formatDataStartDate = handleFormatDataDuplicate(
    missCallData[startDate]
  );
  const formatDataEndData = handleFormatDataDuplicate(missCallData[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};
export const formatDataVmailNatcomCompate = (
  airtime_bitel,
  startDate,
  endDate,
  isAdvance = false
) => {
  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (isAdvance) {
        total = +datas?.total_advance_fee / 100;
      } else {
        total = +datas?.total_recovery_origin_fee / 100;
      }
      defineData[i].total_hour = total || 0;
    }

    return defineData;
  };
  const formatDataStartDate = handleFormatDataDuplicate(
    airtime_bitel[startDate]
  );
  const formatDataEndData = handleFormatDataDuplicate(airtime_bitel[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};

export const formatDataErrorCodeMytelCompate = (
  dataErrorCode,
  startDate,
  endDate,
  code_0 = false,
  code_1 = false,
  code_417 = false,
  code_orther = false,
) => {
  
  const handleGetData = (dataErrorCode, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];
    if (_.isEmpty(dataErrorCode)) {
      return defineData;
    }

    dataErrorCode = dataErrorCode.map(item => {
      const date = new Date(item.report_date);
      const hour = String(date.getHours()).padStart(2, '0'); 
      const minute = String(date.getMinutes()).padStart(2, '0');
      return { ...item, hour: `${hour}:${minute}` };
    });

    for (let i = 0; i < defineData.length; i++) {
      const datas = dataErrorCode.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (code_0) {
        total = +datas?.code_0;
      } else if(code_1) {
        total = +datas?.code_1;
      } else if(code_417) {
        total = +datas?.code_417;
      } else if(code_orther) {
        total = +datas?.code_orther;
      }
      defineData[i].total_hour = total || 0;
    }
    return defineData;
  };
  const formatDataStartDate = dataErrorCode[startDate];
  const formatDataEndData = dataErrorCode[endDate];
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};

export const formatDataVmailUnitelCompate = (
  vm_mytel,
  startDate,
  endDate,
  isMiss = false,
  isCall = false,
  isVm = false,
) => {
  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      let total = 0;
      if (isCall) {
        total = +datas?.total_call;
      } else if (isMiss) {
        total = +datas?.total_miss_call;
      }else if(isVm){
        total = +datas?.total_vm;
      }else{
        total = +datas?.total_fee;
      }
      defineData[i].total_hour = total || 0;
    }

    return defineData;
  };
  const formatDataStartDate = handleFormatDataDuplicate(vm_mytel[startDate]);
  const formatDataEndData = handleFormatDataDuplicate(vm_mytel[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};

export const formatDataNatcomNtmCompate = (ntm, startDate, endDate) => {
  if (_.isEmpty(ntm)) {
    return {};
  }

  const handleGetData = (data, category) => {
    const defineData = [
      { hour: "00:00", total_hour: 0, category },
      { hour: "01:00", total_hour: 0, category },
      { hour: "02:00", total_hour: 0, category },
      { hour: "03:00", total_hour: 0, category },
      { hour: "04:00", total_hour: 0, category },
      { hour: "05:00", total_hour: 0, category },
      { hour: "06:00", total_hour: 0, category },
      { hour: "07:00", total_hour: 0, category },
      { hour: "08:00", total_hour: 0, category },
      { hour: "09:00", total_hour: 0, category },
      { hour: "10:00", total_hour: 0, category },
      { hour: "11:00", total_hour: 0, category },
      { hour: "12:00", total_hour: 0, category },
      { hour: "13:00", total_hour: 0, category },
      { hour: "14:00", total_hour: 0, category },
      { hour: "15:00", total_hour: 0, category },
      { hour: "16:00", total_hour: 0, category },
      { hour: "17:00", total_hour: 0, category },
      { hour: "18:00", total_hour: 0, category },
      { hour: "19:00", total_hour: 0, category },
      { hour: "20:00", total_hour: 0, category },
      { hour: "21:00", total_hour: 0, category },
      { hour: "22:00", total_hour: 0, category },
      { hour: "23:00", total_hour: 0, category },
    ];

    if (_.isEmpty(data)) {
      return defineData;
    }

    for (let i = 0; i < defineData.length; i++) {
      const datas = data.find((item) => item?.hour == defineData[i]?.hour);
      defineData[i].total_hour = +datas?.total_hour || 0;
    }

    return defineData;
  };

  const formatDataStartDate = handleFormatDataDuplicate(ntm[startDate]);
  const formatDataEndData = handleFormatDataDuplicate(ntm[endDate]);
  const dataStart = handleGetData(formatDataStartDate, startDate);
  const dataEnd = handleGetData(formatDataEndData, endDate);
  const data = [...dataStart, ...dataEnd];
  return data;
};

export const formatDataTableStaticMytel = (dataStatisticTable = {}) => {
  const overviewStatisticMytel = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 100,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "Quantity",
        key: "Quantity",
        width: 100,
        fixed: "left",
      },
      {
        title: "Revenue(Kyat)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
            //   sorter: (a, b) => a.age - b.age,
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          {
            title: "MyID",
            dataIndex: "MyID",
            key: "MyID",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Web/Wap",
            dataIndex: "WebWap",
            key: "WebWap",
            with: "auto",
          },
          {
            title: "Total Revenue",
            dataIndex: "TotalRevenue",
            key: "TotalRevenue",
            with: "auto",
            fixed: "right",
          },
        ],
      },
    ],
    defineData: [
      {
        key: "day",
        Package: "Day",
        name: "Day",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "week",
        Package: "Week",
        name: "Week",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "month",
        Package: "Month",
        name: "Month",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "bid",
        Package: "BID",
        name: "BID",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "bid2",
        Package: "BID2",
        name: "BID2",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "bid5",
        Package: "BID5",
        name: "BID5",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "bid10",
        Package: "BID10",
        name: "BID10",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "bid20",
        Package: "BID20",
        name: "BID20",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
      {
        key: "total",
        Package: "Total",
        name: "Total",
        Quantity: 0,
        SMS: 0,
        USSD: 0,
        MyID: 0,
        WebWap: 0,
        TotalRevenue: 0,
      },
    ],
  };

  const { defineData } = overviewStatisticMytel;
  defineData.forEach((data, index) => {
    if (dataStatisticTable[data.key]) {
      const { quantity, my_id, sms, total_revenue, ussd, web_wap } =
        dataStatisticTable[data.key];
      data.Quantity = quantity;
      data.MyID = my_id;
      data.SMS = sms;
      data.TotalRevenue = total_revenue;
      data.USSD = ussd;
      data.WebWap = web_wap;
    }
    return data;
  });
  return overviewStatisticMytel;
};

export const formatDataQuantityRevenueMytel = (dataOverview = {}, type) => {
  const dataDashbordBitelOverview = {
    quantityRevenue: {
      data: [
        {
          time: "Day",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Week",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Month",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Bid",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Bid2",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Bid5",
          totalRevenue: 0,
          quantity: 0,
        },
        {
          time: "Bid10",
          totalRevenue: 0,
          quantity: 0,
        },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },

    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: 0,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: 0,
          id: "ussd",
        },
        {
          type: "MIBITEL",
          revenue: 0,
          id: "mibitel",
        },
        {
          type: "WEB/WAP",
          revenue: 0,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };
  const { quantityRevenue, revenueOfChannel } = dataDashbordBitelOverview;

  quantityRevenue.data.forEach((item) => {
    const dataQuantity =
      dataOverview[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];
    const dataRevenue =
      dataOverview[`revenue_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) item.quantity = dataQuantity;
    if (dataRevenue) item.totalRevenue = dataRevenue;

    return item;
  });
  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataOverview[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });

  revenueOfChannel.data.forEach((item) => {
    const data = dataOverview[`revenue_${item.id}`];
    if (data) {
      item.revenue = data;
    }
  });

  if (type === 1) return quantityRevenue;
  return revenueOfChannel;
};

//bitel
export const formatDataStatisticTable = (dataOverview = []) => {
  const CHANNELS = [
    {
      id: [
        "BUY_MORE_BIDS",
        "SUB_REQUEST",
        "RENEW",
        "REGISTER",
        "CONTENT_REQUEST",
        "SMS",
      ],
      alias: "SMS",
      key: "sms",
      total: 0,
    },
    { id: ["USSD"], alias: "USSD", key: "ussd", total: 0 },
    { id: ["Mibitel", "MyID"], alias: "Mibitel", key: "mibitel", total: 0 },
    {
      id: ["WEB", "WAP", "WEB_REGISTER","OTHER_BUY_MORE_BIDS"],
      alias: "Web_Wap",
      key: "web",
      total: 0,
    },
  ];

  const formatData = dataOverview.map((item) => {
    return { ...item, SMS: 0, USSD: 0, Mibitel: 0, Web_Wap: 0 };
  });

  const convertData = formatData.map((item = {}) => {
    const { channels = [] } = item;
    channels.forEach((dataChannel = {}) => {
      CHANNELS.forEach((defineChannel) => {
        if (_.includes(defineChannel.id, dataChannel.title)) {
          item[defineChannel.alias] =
            item[defineChannel.alias] + Number(dataChannel.amount);
        }
        return defineChannel;
      });
    });
    return item;
  });

  const { sms, ussd, mibitel, web_wap } = totalSubataOverview(dataOverview);
  const columnsBitelRevenue = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 200,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 200,
        // fixed: "left",
      },
      {
        title: "Revenue (Sol)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          {
            title: "Mibitel",
            dataIndex: "Mibitel",
            key: "Mibitel",
            width: "auto",
            // fixed: "right",
          },

          {
            title: "Web/Wap",
            dataIndex: "Web_Wap",
            key: "Web_Wap",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Revenue",
            dataIndex: "total",
            key: "total",
            width: "auto",
            // fixed: "right",
          },
        ],
      },
    ],

    defineData: [
      {
        key: "day",
        Package: "Day",
        name: "Day",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "SUBASTA_DAILY",
      },
      {
        key: "week",
        Package: "Week",
        name: "Week",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "SUBASTA_WEEKLY",
      },
      {
        key: "month",
        Package: "Month",
        name: "Month",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "SUBASTA_MONTHLY",
      },
      {
        key: "chance",
        Package: "Chance",
        name: "Chance",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "CHANCE",
      },
      {
        key: "chance2",
        Package: "Chance2",
        name: "Chance2",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "CHANCE2",
      },
      {
        key: "chance5",
        Package: "Chance5",
        name: "Chance5",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "CHANCE5",
      },
      {
        key: "chance10",
        Package: "Chance10",
        name: "Chance10",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "CHANCE10",
      },
      {
        key: "total",
        Package: "Total",
        name: "Total",
        quantity: 0,
        SMS: sms,
        USSD: ussd,
        Mibitel: mibitel,
        Web_Wap: web_wap,
        total: 0,
      },
    ],
  };

  columnsBitelRevenue.defineData.forEach((item = {}) => {
    convertData.forEach((dataView = {}) => {
      if (dataView.title === item.id) {
        item.Mibitel = roundingNumber(dataView.Mibitel);
        item.SMS = roundingNumber(dataView.SMS);
        item.USSD = roundingNumber(dataView.USSD);
        item.Web_Wap = roundingNumber(dataView.Web_Wap);
        item.quantity = roundingNumber(dataView.quantity);
        item.total = roundingNumber(dataView.total);
      }
    });
  });

  let total = {
    quantity: 0,
    sms: 0,
    ussd: 0,
    mibitel: 0,
    Web_Wap: 0,
    total: 0,
  };

  let dataReturn = columnsBitelRevenue.defineData.map((item) => {
    if (item.key !== "total") {
      total.quantity += item.quantity || 0;
      total.sms += item.SMS || 0;
      total.ussd += item.USSD || 0;
      total.mibitel += item.Mibitel || 0;
      total.Web_Wap += item.Web_Wap || 0;
    }

    if (item.key === "total") {
      item.quantity = total.quantity;
      item.SMS = total.sms;
      item.USSD = total.ussd;
      item.Mibitel = total.mibitel;
      item.Web_Wap = total.Web_Wap;
      // item.revenue
      item.total = roundingNumber(
        total.sms + total.ussd + total.mibitel + total.Web_Wap
      );
    }
    return item;
  });
  dataReturn = dataReturn.map((item = {}) => {
    return {
      ...item,
      Mibitel: formatDataNumberToen(item.Mibitel),
      SMS: formatDataNumberToen(item.SMS),
      USSD: formatDataNumberToen(item.USSD),
      Web_Wap: formatDataNumberToen(item.Web_Wap),
      quantity: formatDataNumberToen(item.quantity),
      total: formatDataNumberToen(item.total),
    };
  });

  return { ...columnsBitelRevenue, defineData: dataReturn };
};

export const formatDataNumberToen = (number = 0) => {
  return number.toLocaleString("en-US");
};

export const formatDataQuantityRevenue = (dataOverview = [], type) => {
  const { sms, ussd, mibitel, web_wap } = totalSubataOverview(dataOverview);
  const dataDashbordBitelOverview = {
    quantityRevenue: {
      data: [
        {
          time: "Day",
          totalRevenue: 0,
          quantity: 0,
          id: "SUBASTA_DAILY",
        },
        {
          time: "Week",
          totalRevenue: 0,
          quantity: 0,
          id: "SUBASTA_WEEKLY",
        },
        {
          time: "Month",
          totalRevenue: 0,
          quantity: 0,
          id: "SUBASTA_MONTHLY",
        },
        {
          time: "Chance",
          totalRevenue: 0,
          quantity: 0,
          id: "CHANCE",
        },
        {
          time: "Chance2",
          totalRevenue: 0,
          quantity: 0,
          id: "CHANCE2",
        },
        {
          time: "Chance5",
          totalRevenue: 0,
          quantity: 0,
          id: "CHANCE5",
        },
        {
          time: "Chance10",
          totalRevenue: 0,
          quantity: 0,
          id: "CHANCE10",
        },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Chance",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Chance2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Chance5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Chance10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },

    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: sms,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: ussd,
          id: "ussd",
        },
        {
          type: "MIBITEL",
          revenue: mibitel,
          id: "mibitel",
        },
        {
          type: "WEB/WAP",
          revenue: web_wap,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };
  const { quantityRevenue, revenueOfChannel } = dataDashbordBitelOverview;
  quantityRevenue.data.forEach((item = {}) => {
    dataOverview.forEach((data = {}) => {
      if (_.lowerCase(item.id) === _.lowerCase(data.title)) {
        item.totalRevenue = roundingNumber(data.total);
        item.quantity = roundingNumber(data.quantity);
      }
    });

    return item;
  });

  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataOverview[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });

  if (type === 1) return quantityRevenue;
  return revenueOfChannel;
};

export const totalSubataOverview = (dataOverview) => {
  let sms = 0;
  let ussd = 0;
  let mibitel = 0;
  let web_wap = 0;

  const CHANNELS = [
    {
      id: [
        "BUY_MORE_BIDS",
        "SUB_REQUEST",
        "RENEW",
        "REGISTER",
        "CONTENT_REQUEST",
        "SMS",
      ],
      alias: "SMS",
      key: "sms",
      total: 0,
    },
    { id: ["USSD"], alias: "USSD", key: "ussd", total: 0 },
    { id: ["Mibitel", "MyID"], alias: "Mibitel", key: "mibitel", total: 0 },
    {
      id: ["WEB", "WAP", "WEB_REGISTER","OTHER_BUY_MORE_BIDS"],
      alias: "Web_Wap",
      key: "web",
      total: 0,
    },
  ];

  dataOverview.forEach((row) => {
    row.channels.forEach((item) => {
      CHANNELS.forEach((channel) => {
        if (channel.id.indexOf(item.title) >= 0) {
          switch (channel.key) {
            case "sms":
              sms = sms + item.amount;
              break;
            case "ussd":
              ussd += item.amount;
              break;
            case "myid":
              mibitel += item.amount;
              break;
            case "web":
              web_wap += item.amount;
              break;
            default:
              break;
          }
        }
      });
    });
  });
  return {
    sms: +roundingNumber(sms),
    ussd: +roundingNumber(ussd),
    mibitel: +roundingNumber(mibitel),
    web_wap: +roundingNumber(web_wap),
  };
};

export const totalMagicOverviewStatic = (dataOverview) => {
  let sms = 0;
  let ussd = 0;
  let system = 0;
  let web_wap = 0;

  const CHANNELS = [
    {
      id: ["SMS"],
      alias: "SMS",
      key: "sms",
      total: 0,
    },
    { id: ["USSD"], alias: "USSD", key: "ussd", total: 0 },
    { id: ["SYSTEM"], alias: "system", key: "system", total: 0 },
    {
      id: ["WEB","WAP"],
      alias: "Web_Wap",
      key: "web",
      total: 0,
    },
  ];

  dataOverview.forEach((row) => {
    row.channels.forEach((item) => {
      CHANNELS.forEach((channel) => {
        if (channel.id.indexOf(item.title) >= 0) {
          switch (channel.key) {
            case "sms":
              sms = sms + item.amount;
              break;
            case "ussd":
              ussd += item.amount;
              break;
            case "system":
              system += item.amount;
              break;
            case "web":
              web_wap += item.amount;
              break;
            default:
              break;
          }
        }
      });
    });
  });
 
  return {
    sms: +roundingNumber(sms),
    ussd: +roundingNumber(ussd),
    system: +roundingNumber(system),
    web_wap: +roundingNumber(web_wap),
  };
};

export const totalMagicOverview = (dataList) => {
  let sms = 0;
  let ussd = 0;
  let system = 0;
  let web_wap = 0;

  const CHANNELS = [
    {
      id: ["SMS"],
      alias: "SMS",
      key: "sms",
      total: 0,
    },
    { 
      id: ["USSD"], 
      alias: "USSD", 
      key: "ussd", 
      total: 0 
    },
    { 
      id: ["SYSTEM"], 
      alias: "System", 
      key: "system", 
      total: 0 
    },
    {
      id: ["WEB","WAP"],
      alias: "Web_Wap",
      key: "web",
      total: 0,
    },
  ];
  dataList.forEach((row) => {
      CHANNELS.forEach((channel) => {
        if (channel.id.indexOf(row.channel) >= 0) {
          switch (channel.key) {
            case "sms":
              sms = sms + row.total_revenue;
              break;
            case "ussd":
              ussd += row.total_revenue;
              break;
            case "system":
              system += row.total_revenue;
              break;
            case "web":
              web_wap += row.total_revenue;
              break;
            default:
              break;
          }
        }
      });
  });
  return {
    sms: +roundingNumber(sms),
    ussd: +roundingNumber(ussd),
    system: +roundingNumber(system),
    web_wap: +roundingNumber(web_wap),
  };
};

export const roundingNumber = (number = 0) => {
  const numStr = number.toString();
  const dotIndex = numStr.indexOf(".");
  if (dotIndex !== -1) {
    const decimalLength = numStr.length - dotIndex - 1;

    if (decimalLength > 3) {
      return parseFloat(number.toFixed(3));
    }
    return number;
  }

  return number;
};

export const formatDataDailyRevenueChart = (dataDetail) => {
  const dataDailyRevenueChart = dataDetail.map((item = {}) => {
    item.chargeTime = item.title;
    let value = 0;
    item.packs.forEach((pack = {}) => {
      value = value + pack.amount;
    });
    item.value = roundingNumber(value);
    return item;
  });
  return dataDailyRevenueChart;
};
//end bitel

export const formatDataDailyRevenueChartAuctionMytelBitel = (dataDetail, service) => {
  const dataDailyRevenueChart = dataDetail.map((item = {}) => {
    item.chargeTime = item.title;
    let value = 0;
    let total_reg_revenue = 0;
    let total_renew_revenue = 0;
    let total_retail_revenue = 0;

    let arrPackRetail = [];
    if(service == 'BITEL'){
      arrPackRetail = ['CHANCE','CHANCE2','CHANCE5','CHANCE10'];
    }else if(service == 'MYTEL'){
      arrPackRetail = ['REVERSE_BID_1','REVERSE_BID_2','REVERSE_BID_5','REVERSE_BID_10','REVERSE_BID_20'];
    }
    item.packs.forEach((pack = {}) => {
      if(arrPackRetail.includes(pack.id)) {
        total_retail_revenue = total_retail_revenue + pack.amount;
      }
      value = value + pack.amount;
      total_reg_revenue = total_reg_revenue + pack.total_reg_revenue;
      total_renew_revenue = total_renew_revenue + pack.total_renew_revenue;
    });
    item.value = roundingNumber(value);
    item.total_reg_revenue = roundingNumber(total_reg_revenue);
    item.total_renew_revenue = roundingNumber(total_renew_revenue);
    item.total_retail_revenue = roundingNumber(total_retail_revenue);
    return item;
  });
  return dataDailyRevenueChart;
};

export const formatDataDailyRevenueChartBicagame = (dataDetail = []) => {
  return dataDetail.map((item = {}) => {
    const reportDate = new Date(item.report_date);

    const day = String(reportDate.getDate()).padStart(2, '0');
    const month = String(reportDate.getMonth() + 1).padStart(2, '0');

    return {
      chargeTime: `${day}/${month}`,
      value: roundingNumber(item.total_revenue),
      total_reg_revenue: roundingNumber(item.register_revenue),
      total_renew_revenue: roundingNumber(item.renew_revenue)
    };
  });
};

export const formatDataDailyRevenueHalogame = (dataDetail = []) => {
  return dataDetail.map((item = {}) => {
    const reportDate = new Date(item.report_date);

    const day = String(reportDate.getDate()).padStart(2, '0');
    const month = String(reportDate.getMonth() + 1).padStart(2, '0');

    return {
      chargeTime: `${day}/${month}`,
      value: roundingNumber(item.total_revenue),
      total_reg_revenue: roundingNumber(item.total_revenue_register),
      total_renew_revenue: roundingNumber(item.total_revenue_renew)
    };
  });
};

export const formatDataDailyRevenueGameUnitel = (dataDetail = []) => {
  return dataDetail.map((item = {}) => {
    const reportDate = new Date(item.time);

    const day = String(reportDate.getDate()).padStart(2, '0');
    const month = String(reportDate.getMonth() + 1).padStart(2, '0');

    return {
      chargeTime: `${day}/${month}`,
      value: roundingNumber(item.revenue_total),
      total_reg_revenue: roundingNumber(item.revenue_register),
      total_renew_revenue: roundingNumber(item.revenue_renew)
    };
  });
};

export const formatDataDailyRevenueChartMagicWheel = (dataDetail) => {
  const dataDailyRevenueChart = dataDetail.map((item = {}) => {
    item.chargeTime = item.title;
    let value = 0;
    let total_reg_revenue = 0;
    let total_renew_revenue = 0;

    let total_retail_revenue = 0;
    const arrPackRetail = ['MAGIC_BUY3','MAGIC_BUY5','MAGIC_BUY10','MAGIC_BUY50'];
    item.packs.forEach((pack = {}) => {
      if(arrPackRetail.includes(pack.id)) {
        total_retail_revenue = total_retail_revenue + pack.amount;
      }
      value = value + pack.amount;
      total_reg_revenue = total_reg_revenue + pack.total_reg_revenue;
      total_renew_revenue = total_renew_revenue + pack.total_renew_revenue;
    });
    item.value = roundingNumber(value);
    item.total_reg_revenue = roundingNumber(total_reg_revenue);
    item.total_renew_revenue = roundingNumber(total_renew_revenue);
    item.total_retail_revenue = roundingNumber(total_retail_revenue);
    return item;
  });
  return dataDailyRevenueChart;
};

export const formatDataDailyRevenueChartMathMatch = (dataDetail) => {
  const dataDailyRevenueChart = dataDetail.map((item = {}) => {
    item.chargeTime = item.title;
    let value = 0;
    let total_reg_revenue = 0;
    let total_renew_revenue = 0;

    let total_retail_revenue = 0;
    const arrPackRetail = [
      'MATH_BUY1',
      'MATH_BUY2',
      'MATH_BUY3',
      'MATH_BUY4',
      'MATH_BUY5',
      'MATH_BUY6',
      'MATH_BUY7',
      'MATH_BUY8',
      'MATH_BUY9',
      'MATH_BUY10',
    ];
    item.packs.forEach((pack = {}) => {
      if(arrPackRetail.includes(pack.id)) {
        total_retail_revenue = total_retail_revenue + pack.amount;
      }
      value = value + pack.amount;
      total_reg_revenue = total_reg_revenue + pack.total_reg_revenue;
      total_renew_revenue = total_renew_revenue + pack.total_renew_revenue;
    });
    item.value = roundingNumber(value);
    item.total_reg_revenue = roundingNumber(total_reg_revenue);
    item.total_renew_revenue = roundingNumber(total_renew_revenue);
    item.total_retail_revenue = roundingNumber(total_retail_revenue);
    return item;
  });
  return dataDailyRevenueChart;
};

export const formatDataDailyRevenueChartMovitel = (dataDetail) => {
  const dataDailyRevenueChart = dataDetail.map((item = {}) => {
    item.chargeTime = item.title;
    let value = 0;
    let total_reg_revenue = 0;
    let total_renew_revenue = 0;

    let total_retail_revenue = 0;
    const arrPackRetail = ['LETRA_MAGICA_MINUS2','LETRA_MAGICA_MINUS3','LETRA_MAGICA_MINUS4','LETRA_MAGICA_MINUS15'];
    item.packs.forEach((pack = {}) => {
      if(arrPackRetail.includes(pack.id)) {
        total_retail_revenue = total_retail_revenue + pack.amount;
      }
      value = value + pack.amount;
      total_reg_revenue = total_reg_revenue + pack.total_reg_revenue;
      total_renew_revenue = total_renew_revenue + pack.total_renew_revenue;
    });
    item.value = roundingNumber(value);
    item.total_reg_revenue = roundingNumber(total_reg_revenue);
    item.total_renew_revenue = roundingNumber(total_renew_revenue);
    item.total_retail_revenue = roundingNumber(total_retail_revenue);
    return item;
  });
  return dataDailyRevenueChart;
};

//start auction bitel
export const formatDataQuantityMytelAuctionOverview = (
  dataOverview = [],
  type
) => {
  const { sms, ussd, mibitel, web_wap } = totalSubataOverview(dataOverview);
  const dataDashbordBitelOverview = {
    quantityRevenue: {
      data: [
        {
          time: "Day",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_DAILY",
        },
        {
          time: "Week",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_WEEKLY",
        },
        {
          time: "Month",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_MONTHLY",
        },
        {
          time: "Bid",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_BID_1",
        },
        {
          time: "Bid2",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_BID_2",
        },
        {
          time: "Bid5",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_BID_5",
        },
        {
          time: "Bid10",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_BID_10",
        },
        {
          time: "Bid20",
          totalRevenue: 0,
          quantity: 0,
          id: "REVERSE_BID_20",
        },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid20",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },
    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: sms,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: ussd,
          id: "ussd",
        },
        {
          type: "MIBITEL",
          revenue: mibitel,
          id: "mibitel",
        },
        {
          type: "WEB/WAP",
          revenue: web_wap,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };

  const { quantityRevenue, revenueOfChannel } = dataDashbordBitelOverview;
  quantityRevenue.data.forEach((item = {}) => {
    dataOverview.forEach((data = {}) => {
      if (_.lowerCase(item.id) === _.lowerCase(data.title)) {
        item.totalRevenue = roundingNumber(data.total);
        item.quantity = roundingNumber(data.quantity);
      }
    });

    return item;
  });
  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataOverview[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });
  if (type === 1) return quantityRevenue;
  const dataConvert = revenueOfChannel?.data?.map((item = {}) => {
    if (item.id === "mibitel") {
      return { type: "MyId", revenue: item.revenue, id: "MyId" };
    }
    return item;
  });

  return { ...revenueOfChannel, data: dataConvert };
};

export const formatDataQuantityMytelMagicWeelOverview = (
  dataList = [],
  type
) => {
  const { sms, ussd, system, web_wap } = totalMagicOverview(dataList);
  const dataMacgicWheel = {
    quantityRevenue: {
      data: [
        {
          time: "Day",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_DAILY",
        },
        {
          time: "Week",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_WEEKLY",
        },
        {
          time: "Month",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_MONTHLY",
        },
        {
          time: "Buy3",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_BUY3",
        },
        {
          time: "Buy5",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_BUY5",
        },
        {
          time: "Buy10",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_BUY10",
        },
        {
          time: "Buy50",
          totalRevenue: 0,
          quantity: 0,
          id: "MAGIC_BUY50",
        },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid20",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },
    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: sms,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: ussd,
          id: "ussd",
        },
        {
          type: "SYSTEM",
          revenue: system,
          id: "system",
        },
        {
          type: "WEB/WAP",
          revenue: web_wap,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };
// 

  const { quantityRevenue, revenueOfChannel } = dataMacgicWheel;
  
  quantityRevenue.data.forEach((item = {}) => {
    dataList.forEach((data = {}) => {
      if (_.lowerCase(item.id) === _.lowerCase(data.package_code)) {
        item.totalRevenue += roundingNumber(data.total_revenue);
        item.quantity += roundingNumber(data.total_reg_renew);
      }
    });

    return item;
  });

  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataList[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });
  if (type === 1) return quantityRevenue;
  const dataConvert = revenueOfChannel?.data?.map((item = {}) => {
    if (item.id === "mibitel") {
      return { type: "MyId", revenue: item.revenue, id: "MyId" };
    }
    return item;
  });

  return { ...revenueOfChannel, data: dataConvert };
};

export const formatDataQuantityMytelMathMatchOverview = (
  dataList = [],
  type
) => {
  const { sms, ussd, system, web_wap } = totalMagicOverview(dataList);
  const dataMacgicWheel = {
    quantityRevenue: {
      data: [
      {
        time: "Daily",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_DAILY",
      },
      {
        time: "Weekly",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_WEEKLY",
      },
      {
        time: "Monthly",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_MONTHLY",
      },
      {
        time: "Tickets3",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY1",
      },
      {
        time: "Tickets10",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY2",
      },
      {
        time: "Tickets50",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY3",
      },
      {
        time: "Hint",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY4",
      },
      {
        time: "Swap",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY5",
      },
      {
        time: "Bomb",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY6",
      },
      {
        time: "Undo",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY7",
      },
      {
        time: "Radar",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY8",
      },
      {
        time: "Revive",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY9",
      },
      {
        time: "Guide",
        totalRevenue: 0,
        quantity: 0,
        id: "MATH_BUY10",
      },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid20",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },
    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: sms,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: ussd,
          id: "ussd",
        },
        {
          type: "SYSTEM",
          revenue: system,
          id: "system",
        },
        {
          type: "WEB/WAP",
          revenue: web_wap,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };


  const { quantityRevenue, revenueOfChannel } = dataMacgicWheel;
  
  quantityRevenue.data.forEach((item = {}) => {
    dataList.forEach((data = {}) => {
      if (_.lowerCase(item.id) === _.lowerCase(data.package_code)) {
        item.totalRevenue += roundingNumber(data.total_revenue);
        item.quantity += roundingNumber(data.total_reg_renew);
      }
    });

    return item;
  });

  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataList[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });
  if (type === 1) return quantityRevenue;
  const dataConvert = revenueOfChannel?.data?.map((item = {}) => {
    if (item.id === "mibitel") {
      return { type: "MyId", revenue: item.revenue, id: "MyId" };
    }
    return item;
  });

  return { ...revenueOfChannel, data: dataConvert };
};

export const formatDataQuantityMovitelOverview = (
  dataList = [],
  type
) => {
  const { sms, ussd, system, web_wap } = totalMagicOverview(dataList);
  const dataMacgicWheel = {
    quantityRevenue: {
      data: [
        {
          time: "Day",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_DAY",
        },
        {
          time: "Week",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_WEEK",
        },
        {
          time: "Month",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MONTH",
        },
        {
          time: "MrDay",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MR_DAY",
        },
        {
          time: "MrMon",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MR_MON",
        },
        {
          time: "MrWeek",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MR_WEEK",
        },
        {
          time: "Minus2",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MINUS2",
        },
        {
          time: "Minus3",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MINUS3",
        },
        {
          time: "Minus4",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MINUS4",
        },
        {
          time: "Minus15",
          totalRevenue: 0,
          quantity: 0,
          id: "LETRA_MAGICA_MINUS15",
        },
      ],
      xField: "time",
      yField: ["totalRevenue", "quantity"],

      // hiện thị đường kẻ
      annotations: {
        quantity: [
          {
            type: "dataMarker",
            time: "Day",
            top: true,
            position: ["", 0],
            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Week",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Month",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid2",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid5",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid10",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
          {
            type: "dataMarker",
            top: true,
            time: "Bid20",
            position: ["", 0],

            text: {
              content: "0",
            },
          },
        ],
      },
    },
    revenueOfChannel: {
      data: [
        {
          type: "SMS",
          revenue: sms,
          id: "sms",
        },
        {
          type: "USSD",
          revenue: ussd,
          id: "ussd",
        },
        {
          type: "SYSTEM",
          revenue: system,
          id: "system",
        },
        {
          type: "WEB/WAP",
          revenue: web_wap,
          id: "web_wap",
        },
      ],
      xField: "type",
      yField: ["revenue"],
    },
  };
// 

  const { quantityRevenue, revenueOfChannel } = dataMacgicWheel;
  
  quantityRevenue.data.forEach((item = {}) => {
    dataList.forEach((data = {}) => {
      if (_.lowerCase(item.id) === _.lowerCase(data.package_code)) {
        item.totalRevenue += roundingNumber(data.total_revenue);
        item.quantity += roundingNumber(data.total_reg_renew);
      }
    });

    return item;
  });

  quantityRevenue.annotations.quantity.forEach((item) => {
    const dataQuantity =
      dataList[`quantity_${_.lowerCase(item.time).split(" ").join("")}`];

    if (dataQuantity) {
      item.position = [item.time, String(dataQuantity)];
      item.text.content = String(dataQuantity);
    }
  });
  if (type === 1) return quantityRevenue;
  const dataConvert = revenueOfChannel?.data?.map((item = {}) => {
    if (item.id === "mibitel") {
      return { type: "MyId", revenue: item.revenue, id: "MyId" };
    }
    return item;
  });

  return { ...revenueOfChannel, data: dataConvert };
};

export const formatDataStatisticTableMytel = (dataOverview = []) => {
  const CHANNELS = [
    {
      id: ["SMS"],
      alias: "SMS",
      key: "sms",
    },
    { id: ["USSD"], 
      alias: "USSD", 
      key: "ussd" },
    { 
      id: ["Mibitel", "MyID"], 
      alias: "Mibitel", 
      key: "mibitel" },
    {
      id: ["WEB", "WAP"],
      alias: "Web_Wap",
      key: "web",
    },
  ];


  const formatData = dataOverview.map((item) => {
    return { ...item, SMS: 0, USSD: 0, Mibitel: 0, Web_Wap: 0 };
  });

  const convertData = formatData.map((item = {}) => {
    const { channels = [] } = item;
    channels.forEach((dataChannel = {}) => {
      CHANNELS.forEach((defineChannel) => {
        if (_.includes(defineChannel.id, dataChannel.title)) {
          item[defineChannel.alias] =
            item[defineChannel.alias] + Number(dataChannel.amount);
        }
        return defineChannel;
      });
    });
    return item;
  });


  const { sms, ussd, mibitel, web_wap } = totalSubataOverview(dataOverview);

  const columnsBitelRevenue = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 100,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        // fixed: "left",
      },
      {
        title: "Revenue (Kyat)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          {
            title: "MyId",
            dataIndex: "Mibitel",
            key: "Mibitel",
            width: "auto",
            // fixed: "right",
          },

          {
            title: "Web/Wap",
            dataIndex: "Web_Wap",
            key: "Web_Wap",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Revenue",
            dataIndex: "total",
            key: "total",
            width: "auto",
            // fixed: "right",
          },
        ],
      },
    ],

    defineData: [
      {
        key: "day",
        Package: "Day",
        name: "Day",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_DAILY",
      },
      {
        key: "week",
        Package: "Week",
        name: "Week",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_WEEKLY",
      },
      {
        key: "month",
        Package: "Month",
        name: "Month",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_MONTHLY",
      },
      {
        key: "bid_1",
        Package: "Bid",
        name: "Bid_1",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_BID_1",
      },
      {
        key: "bid_2",
        Package: "Bid2",
        name: "Bid_2",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_BID_2",
      },
      {
        key: "bid_5",
        Package: "Bid5",
        name: "Bid_5",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_BID_5",
      },
      {
        key: "bit_10",
        Package: "Bid10",
        name: "Bid_10",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_BID_10",
      },
      {
        key: "bid_20",
        Package: "Bid20",
        name: "Bid_20",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        Mibitel: 0,
        Web_Wap: 0,
        total: 0,
        id: "REVERSE_BID_20",
      },
      {
        key: "total",
        Package: "Total",
        name: "Total",
        quantity: 0,
        SMS: sms,
        USSD: ussd,
        Mibitel: mibitel,
        Web_Wap: web_wap,
        total: 0,
      },
    ],
  };


  columnsBitelRevenue.defineData.forEach((item = {}) => {
    convertData.forEach((dataView = {}) => {
      if (dataView.titleConvert === item.id || dataView.title === item.id) {
        item.Mibitel = roundingNumber(dataView.Mibitel);
        item.SMS = roundingNumber(dataView.SMS);
        item.USSD = roundingNumber(dataView.USSD);
        item.Web_Wap = roundingNumber(dataView.Web_Wap);
        item.quantity = roundingNumber(dataView.quantity);
        item.total = roundingNumber(dataView.total);
      }
    });
  });

  let totalQuantity = 0;
  let totalRevenue = 0;
  let dataReturn = columnsBitelRevenue.defineData.map((item) => {
    totalQuantity = totalQuantity + item.quantity;
    totalRevenue = totalRevenue + item.total;
    if (item.key === "total") {
      const { Mibitel, SMS, USSD, Web_Wap, quantity } = item;
      item.quantity = totalQuantity;
      item.total =  totalRevenue;//Mibitel + SMS + USSD + Web_Wap + quantity;
    }
    return item;
  });
  dataReturn = dataReturn.map((item) => {
    for (let x in item) {
      if (typeof item[x] === "number") {
        item[x] = formatDataNumberToen(item[x]);
      }
    }
    return item;
  });
  return { ...columnsBitelRevenue, defineData: dataReturn };
};

export const formatDataStatisticTableMagicWheel = (dataOverview = []) => {
  const CHANNELS = [
      {
        id: ["SMS"],
        alias: "SMS",
        key: "sms",
      },
      { 
        id: ["USSD"], 
        alias: "USSD", 
        key: "ussd", 
      },
      { 
        id: ["SYSTEM"], 
        alias: "SYSTEM", 
        key: "SYSTEM", 
      },
      {
        id: ["WEB","WAP"],
        alias: "Web_Wap",
        key: "web",
      },
    ];  

  const formatData = dataOverview.map((item) => {
    return { ...item, SMS: 0, USSD: 0, SYSTEM: 0, Web_Wap: 0 };
  });

  const convertData = formatData.map((item = {}) => {
    const { channels = [] } = item;
    channels.forEach((dataChannel = {}) => {
      CHANNELS.forEach((defineChannel) => {
        if (_.includes(defineChannel.id, dataChannel.title)) {
          item[defineChannel.alias] =
            item[defineChannel.alias] + Number(dataChannel.amount);
        }
        return defineChannel;
      });
    });
    return item;
  });

  const { sms, ussd, system, web_wap } = totalMagicOverviewStatic(dataOverview);

  const columnsMagicRevenue = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 100,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        // fixed: "left",
      },
      {
        title: "Revenue (Kyat)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          // {
          //   title: "SYSTEM",
          //   dataIndex: "SYSTEM",
          //   key: "SYSTEM",
          //   width: "auto",
          //   // fixed: "right",
          // },

          {
            title: "Web/Wap",
            dataIndex: "Web_Wap",
            key: "Web_Wap",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Register",
            dataIndex: "total_reg_revenue",
            key: "total_reg_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Renew",
            dataIndex: "total_renew_revenue",
            key: "total_renew_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Revenue",
            dataIndex: "total",
            key: "total",
            width: "auto",
            // fixed: "right",
          },
        ],
      },
    ],

    defineData: [
      {
        key: "day",
        Package: "Day",
        name: "Day",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0, 
        id: "MAGIC_DAILY",
      },
      {
        key: "week",
        Package: "Week",
        name: "Week",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "MAGIC_WEEKLY",
      },
      {
        key: "month",
        Package: "Month",
        name: "Month",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0, 
        id: "MAGIC_MONTHLY",
      },
      {
        key: "buy_3",
        Package: "Buy3",
        name: "buy_3",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "MAGIC_BUY3",
      },
      {
        key: "buy_5",
        Package: "Buy5",
        name: "buy_5",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "MAGIC_BUY5",
      },
      {
        key: "buy_10",
        Package: "Buy10",
        name: "buy_10",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "MAGIC_BUY10",
      },
      {
        key: "buy_50",
        Package: "Buy50",
        name: "buy_50",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "MAGIC_BUY50",
      },
      {
        key: "total",
        Package: "Total",
        name: "Total",
        quantity: 0,
        SMS: sms,
        USSD: ussd,
        system: system,
        Web_Wap: web_wap,
        total: 0,
      },
    ],
  };


  columnsMagicRevenue.defineData.forEach((item = {}) => {
    convertData.forEach((dataView = {}) => {
      if (dataView.titleConvert === item.id || dataView.title === item.id) {
        item.SYSTEM = roundingNumber(dataView.SYSTEM);
        item.SMS = roundingNumber(dataView.SMS);
        item.USSD = roundingNumber(dataView.USSD);
        item.Web_Wap = roundingNumber(dataView.Web_Wap);
        item.quantity = roundingNumber(dataView.quantity);
        item.total = roundingNumber(dataView.total);
        item.total_reg_revenue = roundingNumber(dataView.total_reg_revenue);
        item.total_renew_revenue = roundingNumber(dataView.total_renew_revenue);
      }
    });
  });

  let totalQuantity = 0;
  let totalRevenue = 0;
  let totalRegRevenue = 0;
  let totalRenewRevenue = 0;
  let totalUSSD = 0;
  let totalSystem = 0;
  let totalSms = 0;
  let totalWebWap = 0;


  let dataReturn = columnsMagicRevenue.defineData.map((row) => {
    if(row.key != 'total'){
      totalQuantity = totalQuantity + row.quantity;
      totalRevenue = totalRevenue + row.total;
      totalRegRevenue = totalRegRevenue + row.total_reg_revenue;
      totalRenewRevenue = totalRenewRevenue + row.total_renew_revenue;
      totalWebWap = totalWebWap + row.Web_Wap;
      totalUSSD = totalUSSD + row.USSD;
      totalSystem = totalSystem + row.SYSTEM;
      totalSms = totalSms + row.SMS;
    }
    if (row.key === "total") {
      row.quantity = totalQuantity;
      row.USSD = totalUSSD;
      row.SYSTEM = totalSystem;
      row.SMS = totalSms;
      row.Web_Wap = totalWebWap;
      row.total = totalRevenue;
      row.total_reg_revenue = totalRegRevenue;
      row.total_renew_revenue = totalRenewRevenue;
    }
    return row;
  });
  
  dataReturn = dataReturn.map((item) => {
    for (let x in item) {
      if (typeof item[x] === "number") {
        item[x] = formatDataNumberToen(item[x]);
      }
    }
    return item;
  });
  return { ...columnsMagicRevenue, defineData: dataReturn };
};
export const formatDataStatisticTableMathMatch = (dataOverview = []) => {
  const CHANNELS = [
      {
        id: ["SMS"],
        alias: "SMS",
        key: "sms",
      },
      { 
        id: ["USSD"], 
        alias: "USSD", 
        key: "ussd", 
      },
      { 
        id: ["SYSTEM"], 
        alias: "SYSTEM", 
        key: "SYSTEM", 
      },
      {
        id: ["WEB","WAP"],
        alias: "Web_Wap",
        key: "web",
      },
    ];  

  const formatData = dataOverview.map((item) => {
    return { ...item, SMS: 0, USSD: 0, SYSTEM: 0, Web_Wap: 0 };
  });

  const convertData = formatData.map((item = {}) => {
    const { channels = [] } = item;
    channels.forEach((dataChannel = {}) => {
      CHANNELS.forEach((defineChannel) => {
        if (_.includes(defineChannel.id, dataChannel.title)) {
          item[defineChannel.alias] =
            item[defineChannel.alias] + Number(dataChannel.amount);
        }
        return defineChannel;
      });
    });
    return item;
  });

  const { sms, ussd, system, web_wap } = totalMagicOverviewStatic(dataOverview);

  const columnsMagicRevenue = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 100,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        // fixed: "left",
      },
      {
        title: "Revenue (Kyat)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          // {
          //   title: "SYSTEM",
          //   dataIndex: "SYSTEM",
          //   key: "SYSTEM",
          //   width: "auto",
          //   // fixed: "right",
          // },

          {
            title: "Web/Wap",
            dataIndex: "Web_Wap",
            key: "Web_Wap",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Register",
            dataIndex: "total_reg_revenue",
            key: "total_reg_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Renew",
            dataIndex: "total_renew_revenue",
            key: "total_renew_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Revenue",
            dataIndex: "total",
            key: "total",
            width: "auto",
            // fixed: "right",
          },
        ],
      },
    ],

    defineData: [
    {
      key: "daily",
      Package: "Daily",
      name: "Daily",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_DAILY",
    },
    {
      key: "weekly",
      Package: "Weekly",
      name: "Weekly",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_WEEKLY",
    },
    {
      key: "monthly",
      Package: "Monthly",
      name: "Monthly",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_MONTHLY",
    },
    {
      key: "tickets3",
      Package: "Tickets3",
      name: "Tickets3",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY1",
    },
    {
      key: "tickets10",
      Package: "Tickets10",
      name: "Tickets10",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY2",
    },
    {
      key: "tickets50",
      Package: "Tickets50",
      name: "Tickets50",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY3",
    },
    {
      key: "hint",
      Package: "Hint",
      name: "Hint",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY4",
    },
    {
      key: "swap",
      Package: "Swap",
      name: "Swap",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY5",
    },
    {
      key: "bomb",
      Package: "Bomb",
      name: "Bomb",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY6",
    },
    {
      key: "undo",
      Package: "Undo",
      name: "Undo",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY7",
    },
    {
      key: "radar",
      Package: "Radar",
      name: "Radar",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY8",
    },
    {
      key: "revive",
      Package: "Revive",
      name: "Revive",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY9",
    },
    {
      key: "guide",
      Package: "Guide",
      name: "Guide",
      quantity: 0,
      SMS: 0,
      USSD: 0,
      system: 0,
      Web_Wap: 0,
      total: 0,
      total_reg_revenue: 0,
      total_renew_revenue: 0,
      id: "MATH_BUY10",
    },
    {
      key: "total",
      Package: "Total",
      name: "Total",
      quantity: 0,
      SMS: sms,
      USSD: ussd,
      system: system,
      Web_Wap: web_wap,
      total: 0,
    },
  ]
  };


  columnsMagicRevenue.defineData.forEach((item = {}) => {
    convertData.forEach((dataView = {}) => {
      if (dataView.titleConvert === item.id || dataView.title === item.id) {
        item.SYSTEM = roundingNumber(dataView.SYSTEM);
        item.SMS = roundingNumber(dataView.SMS);
        item.USSD = roundingNumber(dataView.USSD);
        item.Web_Wap = roundingNumber(dataView.Web_Wap);
        item.quantity = roundingNumber(dataView.quantity);
        item.total = roundingNumber(dataView.total);
        item.total_reg_revenue = roundingNumber(dataView.total_reg_revenue);
        item.total_renew_revenue = roundingNumber(dataView.total_renew_revenue);
      }
    });
  });

  let totalQuantity = 0;
  let totalRevenue = 0;
  let totalRegRevenue = 0;
  let totalRenewRevenue = 0;
  let totalUSSD = 0;
  let totalSystem = 0;
  let totalSms = 0;
  let totalWebWap = 0;


  let dataReturn = columnsMagicRevenue.defineData.map((row) => {
    if(row.key != 'total'){
      totalQuantity = totalQuantity + row.quantity;
      totalRevenue = totalRevenue + row.total;
      totalRegRevenue = totalRegRevenue + row.total_reg_revenue;
      totalRenewRevenue = totalRenewRevenue + row.total_renew_revenue;
      totalWebWap = totalWebWap + row.Web_Wap;
      totalUSSD = totalUSSD + row.USSD;
      totalSystem = totalSystem + row.SYSTEM;
      totalSms = totalSms + row.SMS;
    }
    if (row.key === "total") {
      row.quantity = totalQuantity;
      row.USSD = totalUSSD;
      row.SYSTEM = totalSystem;
      row.SMS = totalSms;
      row.Web_Wap = totalWebWap;
      row.total = totalRevenue;
      row.total_reg_revenue = totalRegRevenue;
      row.total_renew_revenue = totalRenewRevenue;
    }
    return row;
  });
  
  dataReturn = dataReturn.map((item) => {
    for (let x in item) {
      if (typeof item[x] === "number") {
        item[x] = formatDataNumberToen(item[x]);
      }
    }
    return item;
  });
  return { ...columnsMagicRevenue, defineData: dataReturn };
};

export const formatDataStatisticTableMovitel = (dataOverview = []) => {
  const CHANNELS = [
      {
        id: ["SMS"],
        alias: "SMS",
        key: "sms",
      },
      { 
        id: ["USSD"], 
        alias: "USSD", 
        key: "ussd", 
      },
      { 
        id: ["SYSTEM"], 
        alias: "SYSTEM", 
        key: "SYSTEM", 
      },
      {
        id: ["WEB","WAP"],
        alias: "Web_Wap",
        key: "web",
      },
    ];  

  const formatData = dataOverview.map((item) => {
    return { ...item, SMS: 0, USSD: 0, SYSTEM: 0, Web_Wap: 0 };
  });

  const convertData = formatData.map((item = {}) => {
    const { channels = [] } = item;
    channels.forEach((dataChannel = {}) => {
      CHANNELS.forEach((defineChannel) => {
        if (_.includes(defineChannel.id, dataChannel.title)) {
          item[defineChannel.alias] =
            item[defineChannel.alias] + Number(dataChannel.amount);
        }
        return defineChannel;
      });
    });
    return item;
  });

  const { sms, ussd, system, web_wap } = totalMagicOverviewStatic(dataOverview);

  const columnsMagicRevenue = {
    dataKey: [
      {
        title: "Package",
        dataIndex: "Package",
        key: "Package",
        width: 100,
        fixed: "left",
      },
      {
        title: "Quantity",
        dataIndex: "quantity",
        key: "quantity",
        width: 100,
        // fixed: "left",
      },
      {
        title: "Revenue (Kyat)",
        children: [
          {
            title: "SMS",
            dataIndex: "SMS",
            key: "SMS",
            width: "auto",
          },
          {
            title: "USSD",
            dataIndex: "USSD",
            key: "USSD",
            width: "auto",
          },
          // {
          //   title: "SYSTEM",
          //   dataIndex: "SYSTEM",
          //   key: "SYSTEM",
          //   width: "auto",
          //   // fixed: "right",
          // },

          {
            title: "Web/Wap",
            dataIndex: "Web_Wap",
            key: "Web_Wap",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Register",
            dataIndex: "total_reg_revenue",
            key: "total_reg_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Renew",
            dataIndex: "total_renew_revenue",
            key: "total_renew_revenue",
            width: "auto",
            // fixed: "right",
          },
          {
            title: "Total Revenue",
            dataIndex: "total",
            key: "total",
            width: "auto",
            // fixed: "right",
          },
        ],
      },
    ],

    defineData: [
      {
        key: "day",
        Package: "Day",
        name: "Day",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0, 
        id: "LETRA_MAGICA_DAY",
      },
      {
        key: "week",
        Package: "Week",
        name: "Week",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_WEEK",
      },
      {
        key: "month",
        Package: "Month",
        name: "Month",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0, 
        id: "LETRA_MAGICA_MONTH",
      },
      {
        key: "mr_day",
        Package: "MrDay",
        name: "mr_day",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MR_DAY",
      },
      {
        key: "mr_mon",
        Package: "MrMon",
        name: "mr_mon",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MR_MON",
      },
      {
        key: "mr_week",
        Package: "MrWeek",
        name: "mr_week",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MR_WEEK",
      },
      {
        key: "minus_2",
        Package: "Minus2",
        name: "minus_2",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MINUS2",
      },
       {
        key: "minus_3",
        Package: "Minus3",
        name: "minus_3",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MINUS3",
      },
       {
        key: "minus_4",
        Package: "Minus4",
        name: "minus_4",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MINUS4",
      },
       {
        key: "minus_15",
        Package: "Minus15",
        name: "minus_15",
        quantity: 0,
        SMS: 0,
        USSD: 0,
        system: 0,
        Web_Wap: 0,
        total: 0,
        total_reg_revenue: 0,  
        total_renew_revenue: 0,         
        id: "LETRA_MAGICA_MINUS15",
      },
      {
        key: "total",
        Package: "Total",
        name: "Total",
        quantity: 0,
        SMS: sms,
        USSD: ussd,
        system: system,
        Web_Wap: web_wap,
        total: 0,
      },
    ],
  };


  columnsMagicRevenue.defineData.forEach((item = {}) => {
    convertData.forEach((dataView = {}) => {
      if (dataView.titleConvert === item.id || dataView.title === item.id) {
        item.SYSTEM = roundingNumber(dataView.SYSTEM);
        item.SMS = roundingNumber(dataView.SMS);
        item.USSD = roundingNumber(dataView.USSD);
        item.Web_Wap = roundingNumber(dataView.Web_Wap);
        item.quantity = roundingNumber(dataView.quantity);
        item.total = roundingNumber(dataView.total);
        item.total_reg_revenue = roundingNumber(dataView.total_reg_revenue);
        item.total_renew_revenue = roundingNumber(dataView.total_renew_revenue);
      }
    });
  });

  let totalQuantity = 0;
  let totalRevenue = 0;
  let totalRegRevenue = 0;
  let totalRenewRevenue = 0;
  let totalUSSD = 0;
  let totalSystem = 0;
  let totalSms = 0;
  let totalWebWap = 0;


  let dataReturn = columnsMagicRevenue.defineData.map((row) => {
    if(row.key != 'total'){
      totalQuantity = totalQuantity + row.quantity;
      totalRevenue = totalRevenue + row.total;
      totalRegRevenue = totalRegRevenue + row.total_reg_revenue;
      totalRenewRevenue = totalRenewRevenue + row.total_renew_revenue;
      totalWebWap = totalWebWap + row.Web_Wap;
      totalUSSD = totalUSSD + row.USSD;
      totalSystem = totalSystem + row.SYSTEM;
      totalSms = totalSms + row.SMS;
    }
    if (row.key === "total") {
      row.quantity = totalQuantity;
      row.USSD = totalUSSD;
      row.SYSTEM = totalSystem;
      row.SMS = totalSms;
      row.Web_Wap = totalWebWap;
      row.total = totalRevenue;
      row.total_reg_revenue = totalRegRevenue;
      row.total_renew_revenue = totalRenewRevenue;
    }
    return row;
  });
  
  dataReturn = dataReturn.map((item) => {
    for (let x in item) {
      if (typeof item[x] === "number") {
        item[x] = formatDataNumberToen(item[x]);
      }
    }
    return item;
  });
  return { ...columnsMagicRevenue, defineData: dataReturn };
};

export const exportExcel = (data, type) => {
  let dataItem = [];
  if (!_.isEmpty(data)) {
    for (const property in data) {
      const totalItem = _.last(data[property]) || {};
      let item = {};
      switch (type) {
        case "airtime_natcom":
          item = {
            date: totalItem.date,
            total_advance_fee: totalItem.total_advance_fee,
            total_fee: totalItem.total_fee,
            total_advance: totalItem.total_advance,
            total_recovery_origin_fee: totalItem.total_recovery_origin_fee,
            total_recovery_fee: totalItem.total_recovery_fee,
            total_trans_recovery: totalItem.total_trans_recovery,
          };
          break;
        case "vm_unitel":
          item = {
            date: totalItem.date,
            d_qty_vm: totalItem.d_qty_vm,
            d_total_fee: totalItem.d_total_fee,
            d_total_duration: totalItem.d_total_duration,
            d_total_missed_call: totalItem.d_total_missed_call,
            d_total_listen_again: totalItem.d_total_listen_again,
          };
          break;
        case "ntm_natcom":
          item = {
            date: totalItem.date,
            qty_day: totalItem.qty_day,
            total_day: totalItem.total_day,
            notify: totalItem.notify,
          };
          break;
        case "vm_mytel":
          item = {
            date: totalItem.date,
            total_call: totalItem.total_call,
            total_miss_call: totalItem.total_miss_call,
            total_call_service: totalItem.total_call_service,
            total_vm: totalItem.total_vm,
            total_vm_duration: totalItem.total_vm_duration,
            total_service_duration: totalItem.total_service_duration,
            total_fee: totalItem.total_fee,
          };
          break;
        case "miss_call_errors":
          item = {
            date: totalItem.date,
            total: totalItem.total,
            check_sub_error: totalItem.check_sub_error,
            not_enough_money: totalItem.not_enough_money,
            cancel: totalItem.cancel,
          };
          break;
      }

      dataItem = [...dataItem, item];
    }
  }

  const dataExport = dataItem.sort(
    (a, b) => new Date(b.date) - new Date(a.date)
  );
  let bodyData = [];
  let header = [];
  switch (type) {
    case "airtime_natcom":
      bodyData = dataExport?.map((item) => [
        item.date,
        item.total_advance_fee,
        item.total_fee,
        item.total_advance,
        item.total_recovery_origin_fee,
        item.total_recovery_fee,
        item.total_trans_recovery,
      ]);
      header = [
        "date",
        "Tổng tiền ứng + phí",
        "Tổng phí",
        "Tổng giao dịch ứng",
        "Tổng tiền thu hồi gốc + phí",
        "Tổng tiền thu hồi phí",
        "Tổng giao dịch thu hồi",
      ];
      break;
    case "vm_unitel":
      bodyData = dataExport?.map((item) => [
        item.date,
        item.d_qty_vm,
        item.d_total_fee,
        item.d_total_duration,
        item.d_total_missed_call,
        item.d_total_listen_again,
      ]);
      header = [
        "Date",
        "Quantity VM",
        "Total Fee",
        "Total duration VM",
        "Total miss call",
        "Total listen again",
      ];
      break;
    case "vm_natcom":
      bodyData = data?.map((item) => [
        item?.date,
        item?.qty_day_0,
        item?.total_day_0,
        item?.qty_day_55,
        item?.total_day_55,
        item?.qty_day_other,
        item?.total_day_other,
        item?.qty_digicel,
        item?.total_digicel,
        item?.time_digicel,
      ]);
      header = [
        "Date",
        "0 - SỐ LƯỢNG",
        "0 - DOANH THU",
        "55 - SỐ LƯỢNG",
        "55- DOANH THU",
        "# - SỐ LƯỢNG",
        "# - DOANH THU",
        "SỐ LƯỢNG DIGICEL",
        "DOANH THU DIGICEL",
        "TIME DIGICEL",
      ];
      break;
    case "ntm_natcom":
      bodyData = dataExport?.map((item) => [
        item.date,
        item.qty_day,
        item.total_day,
        item.notify,
      ]);
      header = ["Date", "0 - SỐ LƯỢNG", "0 - DOANH THU", "Notify"];
      break;
    case "vm_mytel":
      bodyData = dataExport?.map((item) => [
        item.date,
        item.total_call,
        item.total_miss_call,
        item.total_call_service,
        item.total_vm,
        item.total_vm_duration,
        item.total_service_duration,
        item.total_fee,
      ]);
      header = ["Date", "Total call", "Total miss call", "Total call service", "Total VM", "Total VM duration", "Total service duration", "Total revenue"];
      break;
    case "miss_call_errors":
      bodyData = dataExport?.map((item) => [
        item.date,
        item.total,
        item.check_sub_error,
        item.not_enough_money,
        item.cancel,
      ]);
      header = ["Date", "Total Errors", "Check Sub Error", "Not Enough Money", "Cancel"];
      break;
    default:
      bodyData = [];
      header = [];
      break;
  }
  if (dataExport?.length > 0) {
    const worksheetData = [header];
    const columnWidths = [
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
      { wch: 20 },
    ];
    const finalData = [...worksheetData, ...bodyData];
    const ws = XLSX.utils.aoa_to_sheet(finalData);
    const wb = XLSX.utils.book_new();
    ws["!cols"] = columnWidths;
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    XLSX.writeFile(wb, `report_${type}.xlsx`);
  }
};

export const formatDataMytelMagicDetail = (data) => {
  if (_.isEmpty(data)) {
    return {};
  }
  const dataKey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: "auto",
    },
    {
      title: "Total Register",
      dataIndex: "total_reg",
      key: "total_reg",
      width: "auto",
    },
    {
      title: "Total Register Revenue",
      dataIndex: "total_reg_revenue",
      key: "total_reg_revenue",
      width: "auto",
    },
    {
      title: "Total Renew",
      dataIndex: "total_renew",
      key: "total_renew",
      width: "auto",
    },
    {
      title: "Total Renew Revenue",
      dataIndex: "total_renew_revenue",
      key: "total_renew_revenue",
      width: "auto",
    },
    {
      title: "Total Reg & Renew",
      dataIndex: "total_reg_renew",
      key: "total_reg_renew",
      width: "auto",
    },
    {
      title: "Total Revenue",
      dataIndex: "total_revenue",
      key: "total_revenue",
      width: "auto",
    },
  ];

  const formatData = handleFormatDataDuplicate(data);
  let defineData = formatData.map((item = {}, index) => {
    const dataConvert = {
      key: item.hour,
      hour: item.hour,
      total_reg: formatDataNumberToen(+item.total_reg || 0),
      total_reg_renew: formatDataNumberToen(+item.total_reg_renew || 0),
      total_reg_revenue: formatDataNumberToen(+item.total_reg_revenue || 0),
      total_renew: formatDataNumberToen(+item.total_renew || 0),
      total_renew_revenue: formatDataNumberToen(+item.total_renew_revenue || 0),
      total_revenue: formatDataNumberToen(+item.total_revenue || 0),
    };

    return dataConvert;
  });
  const dataAllday = formatData.reduce(
    (acc, item) => {
      acc.total_reg += +item.total_reg || 0;
      acc.total_reg_renew += +item.total_reg_renew || 0;
      acc.total_reg_revenue += +item.total_reg_revenue || 0;
      acc.total_renew += +item.total_renew || 0;
      acc.total_renew_revenue += +item.total_renew_revenue || 0;
      acc.total_revenue += +item.total_revenue || 0;
      return acc;
    },
    {
      key: "ALL DAY",
      hour: "ALL DAY",
      total_reg: 0,
      total_reg_renew: 0,
      total_reg_revenue: 0,
      total_renew: 0,
      total_renew_revenue: 0,
      total_revenue: 0,
    }
  );

  Object.keys(dataAllday).forEach((key) => {
    if (key !== "key" && key !== "hour") {
      dataAllday[key] = formatDataNumberToen(dataAllday[key]);
    }
  });
  defineData = [...defineData, dataAllday];
  return {
    dataKey,
    defineData: formatDataTableDetailNatcom(defineData),
  };
};
export const formatDataMytelDetail = (data) => {
  if (_.isEmpty(data)) {
    return {};
  }
  const dataKey = [
    {
      title: "HOUR",
      dataIndex: "hour",
      key: "hour",
      width: "auto",
    },
    {
      title: "Total Charge",
      dataIndex: "total_num_charge",
      key: "total_num_charge",
      width: "auto",
    },
    {
      title: "Total Charge Success",
      dataIndex: "total_num_charge_success",
      key: "total_num_charge_success",
      width: "auto",
    },
    {
      title: "Total Register Revenue",
      dataIndex: "revenue_register",
      key: "revenue_register",
      width: "auto",
    },
    {
      title: "Total Renew Revenue",
      dataIndex: "revenue_renew",
      key: "revenue_renew",
      width: "auto",
    },
    {
      title: "Total Revenue",
      dataIndex: "total_revenue",
      key: "total_revenue",
      width: "auto",
    },
  ];

  const formatData = handleFormatDataDuplicate(data);
  let defineData = formatData.map((item = {}, index) => {
    const dataConvert = {
      key: item.hour,
      hour: `${item.hour}:00`,
      total_num_charge: formatDataNumberToen(+item.total_num_charge || 0),
      total_num_charge_success: formatDataNumberToen(+item.total_num_charge_success || 0),
      revenue_register: formatDataNumberToen(+item.revenue_register || 0),
      revenue_renew: formatDataNumberToen(+item.revenue_renew || 0),
      total_revenue: formatDataNumberToen(+item.total_revenue || 0),
    };

    return dataConvert;
  });
  const dataAllday = formatData.reduce(
    (acc, item) => {
      acc.total_num_charge += +item.total_num_charge || 0;
      acc.total_num_charge_success += +item.total_num_charge_success || 0;
      acc.revenue_register += +item.revenue_register || 0;
      acc.revenue_renew += +item.revenue_renew || 0;
      acc.total_revenue += +item.total_revenue || 0;
      return acc;
    },
    {
      key: "ALL DAY",
      hour: "ALL DAY",
      total_num_charge: 0,
      total_num_charge_success: 0,
      revenue_register: 0,
      revenue_renew: 0,
      total_revenue: 0,
    }
  );

  Object.keys(dataAllday).forEach((key) => {
    if (key !== "key" && key !== "hour") {
      dataAllday[key] = formatDataNumberToen(dataAllday[key]);
    }
  });
  defineData = [...defineData, dataAllday];
  return {
    dataKey,
    defineData: formatDataTableDetailNatcom(defineData),
  };
};
